
// // // export default Home;
// //    import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [zoneDepartment, setZoneDepartment] = useState('');
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
// // const API_BASE_URL = 'https://api.stdl.site';
// //         // try {
// //         //     const response = await fetch(`${API_BASE_URL}/flight-arrival`, {
// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   // Submit participation form
// //   const handleFormSubmit = async (e) => {
// //   e.preventDefault();

// //   if (!numParticipants.trim()) {
// //     alert('Please fill in all fields');
// //     return;
// //   }

// //   if (Number(numParticipants) < 1) {
// //     alert('Number of participants must be at least 1');
// //     return;
// //   }

// //   try {
// //     setLoadingForm(true);
// //     await axios.post(`${API_BASE_URL}/participation`, {
// //       userId: currentUser?.portalID,
// //       name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //       department: currentUser?.deptName,
// //       participants: numParticipants,
// //     });

// //     setFormSubmitted(true);
// //   } catch (error) {
// //     console.error("Error submitting participation form:", error);
// //     alert("There was an issue submitting the form. Try again.");
// //   } finally {
// //     setLoadingForm(false);
// //   }
// // };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, {
// //         userId: currentUser?.portalID,
// //       });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const picture = currentUser?.picturePath;
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: picture },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);

// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   // If form not submitted, show form
// //   if (!formSubmitted) {
// //     return (
// //       <div className="participation-form-container">
// //         <h2 className="form-title">Participation Form</h2>
// //         <form onSubmit={handleFormSubmit} className="participation-form">


// //           <label>
// //             Number of Participants:
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //                min="1"
// //               required
// //             />
// //           </label>

// //           <button type="submit" disabled={loadingForm}>
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   // Once form is submitted, show original Home content
// //   return (
// //     <div className="home-container">
// //     <div className="logout">
// //       <button className="logout-btn" onClick={handleLogout}>
// //         Logout
// //       </button>
// // </div>
// //       {/* <div className="banner">
// //         <img
// //           src="https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L1JlTUM5YnM4TEZ1SDY2N3E0a1BRZz09/Prayer_time_new.jpg"
// //           alt="Program Banner"
// //         />
// //       </div> */}
// //  <h2 className="text">Live Streaming</h2>

// //       <div className="video-container">
// //         <VideoPlayer />
     
// //   {/* <a 
// //     href="https://stdl.site/Media/Hyperlink/GLOBAL%20STAFF%20TRAINING/The_Last_Lap_of_Completing_Program_Line_Up_1%20%283%29.docx" 
// //     target="_blank" 
// //     rel="noopener noreferrer"
// //     style={{
// //       display: 'block',
// //       marginTop: '15px',
// //       textAlign: 'center',
// //       color: '#007bff',
// //       textDecoration: 'underline',
// //       fontSize: '16px',
// //       fontWeight: '500',
// //     }}
// //   >
// //     📄 Click to View Program Outline
// //   </a> */}
// //       </div>

// //       <div className="social-main">
// //         <div className="social-actions">
// //           <div className="reaction">
// //             <div className="like" onClick={handleToggleLike}>
// //               <span role="img" aria-label="like">
// //                 {liked ? <FavoriteOutlinedIcon /> : <FavoriteBorderOutlinedIcon />}
// //               </span>
// //               {totalLikes !== null ? `${totalLikes}` : null}
// //             </div>

// //             <div className="comment-count">
// //               <span role="img" aria-label="comment">💬</span>
// //               {totalComments} Comments
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="comments">
// //         <div className="write">
// //           <img
// //             src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png"
// //             alt="Profile"
// //           />
// //           <input
// //             type="text"
// //             placeholder="Write a comment..."
// //             value={newComment}
// //             onChange={(e) => setNewComment(e.target.value)}
// //           />
// //           <button onClick={handleCreateComment} disabled={loading}>
// //             {loading ? 'Sending...' : 'Send'}
// //           </button>
// //         </div>

// //         {comments.map((comment) => (
// //           <div className="comment" key={comment._id}>
// //             <img src={comment.picture?.uri} alt="" />
// //             <div className="info">
// //               <span className="department">{comment.department}</span>
// //               <span className="name">{comment.name}</span>
// //               <p className="msg">{comment.text}</p>
// //             </div>
// //             <span className="date">
// //               {new Date(comment.createdAt).toLocaleString()}
// //             </span>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default Home;


// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program'
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide'
// //     },
// //     // {
// //     //   url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png',
// //     //   title: 'STDL TV',
// //     //   subtitle: 'Live Streaming Available'
// //     // }
// //   ];

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const nextSlide = () => {
// //     setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   };

// //   const prevSlide = () => {
// //     setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
// //   };

// //   useEffect(() => {
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!numParticipants.trim()) {
// //       alert('Please fill in all fields');
// //       return;
// //     }

// //     if (Number(numParticipants) < 1) {
// //       alert('Number of participants must be at least 1');
// //       return;
// //     }

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });

// //       setFormSubmitted(true);
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, {
// //         userId: currentUser?.portalID,
// //       });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const picture = currentUser?.picturePath;
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: picture },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);

// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   if (!formSubmitted) {
// //     return (
// //       <div className="participation-form-container">
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={handleFormSubmit} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="home-container">
// //       {/* Top Bar */}
// //       <div className="top-bar">
// //         <div className="top-bar-left">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //         </div>
// //         <div className="top-bar-right">
// //           <button className="logout-btn" onClick={handleLogout}>
// //             <span className="logout-icon">🚪</span>
// //             <span className="logout-text">Logout</span>
// //           </button>
// //         </div>
// //       </div>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className="sidebar-overlay"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className="sidebar"
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png" 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>
// //               <nav className="sidebar-nav">
// //                 <a href="#" className="sidebar-link active">
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
// //                 <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">📺</span>
// //                   Live Stream
// //                 </a>
// //                 <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">📄</span>
// //                   Program Outline
// //                 </a>
// //                 <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">💬</span>
// //                   Messages
// //                 </a>
// //                 <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">👥</span>
// //                   Participants
// //                 </a>
// //                 <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">⚙️</span>
// //                   Settings
// //                 </a>
// //               </nav>
// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className="welcome-banner">
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h3>Good Evening,</h3>
// //             <h2>Welcome back, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h2>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //           <div className="welcome-date">
// //             <span className="date-text">July 2026</span>
// //             <span className="month-text">The Month of Completion</span>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide"
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //               <div className="slide-overlay">
// //                 <div className="slide-content">
// //                   <h3>{sliderImages[currentSlide].title}</h3>
// //                   <p>{sliderImages[currentSlide].subtitle}</p>
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* Live Streaming Section */}
// //       <div className="section-header">
// //         <h2 className="text">📺 Live Streaming</h2>
// //         <a 
// //           href="https://stdl.site/Media/Hyperlink/GLOBAL%20STAFF%20TRAINING/The_Last_Lap_of_Completing_Program_Line_Up_1%20%283%29.docx" 
// //           target="_blank" 
// //           rel="noopener noreferrer"
// //           className="program-outline-link"
// //         >
// //           📄 View Program Outline
// //         </a>
// //       </div>

// //       <div className="video-container">
// //         <VideoPlayer />
// //       </div>

// //       {/* Social Actions */}
// //       <div className="social-main">
// //         <div className="social-actions">
// //           <div className="reaction">
// //             <div className="like" onClick={handleToggleLike}>
// //               <span role="img" aria-label="like">
// //                 {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //               </span>
// //               <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //             </div>

// //             <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //               <span role="img" aria-label="comment">💬</span>
// //               <span className="count">{totalComments}</span>
// //               <span className="label">Comments</span>
// //             </div>
// //           </div>
// //         </div>
// //       </div>


// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className="comments-modal-overlay"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className="comments-modal"
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 <div className="write">
// //                   <img
// //                     src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png"
// //                     alt="Profile"
// //                   />
// //                   <input
// //                     type="text"
// //                     placeholder="Write a comment..."
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <button onClick={handleCreateComment} disabled={loading}>
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png'} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;



// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
// //   const [isDarkTheme, setIsDarkTheme] = useState(false);
// //   const [hasNotifications, setHasNotifications] = useState(true);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program'
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide'
// //     },
// //   ];

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const toggleTheme = () => {
// //     setIsDarkTheme(!isDarkTheme);
// //     document.body.classList.toggle('dark-theme');
// //   };

// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     // You can add your notification logic here
// //     alert('📬 You have 3 new notifications');
// //   };

// //   const nextSlide = () => {
// //     setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   };

// //   const prevSlide = () => {
// //     setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
// //   };

// //   useEffect(() => {
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!numParticipants.trim()) {
// //       alert('Please fill in all fields');
// //       return;
// //     }

// //     if (Number(numParticipants) < 1) {
// //       alert('Number of participants must be at least 1');
// //       return;
// //     }

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });

// //       setFormSubmitted(true);
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, {
// //         userId: currentUser?.portalID,
// //       });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const picture = currentUser?.picturePath;
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: picture },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);

// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   if (!formSubmitted) {
// //     return (
// //       <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={handleFormSubmit} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }
// // //Live Streaming
// //   return (
// //     <div className={`home-container ${isDarkTheme ? 'dark' : ''}`}>
// //       {/* Top Bar */}
// //       <div className="top-bar">
// //         <div className="top-bar-left">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //         </div>
// //         <div className="top-bar-right">
// //           {/* Theme Toggle */}
// //           <button className="theme-toggle" onClick={toggleTheme} title="Toggle Theme">
// //             {isDarkTheme ? '☀️' : '🌙'}
// //           </button>

// //           {/* Notification Bell */}
// //           <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //             {hasNotifications ? (
// //               <>
// //                 <NotificationsIcon className="notification-icon" />
// //                 <span className="notification-badge">3</span>
// //               </>
// //             ) : (
// //               <NotificationsNoneIcon className="notification-icon" />
// //             )}
// //           </button>

// //           {/* Logout Button */}
// //           <button className="logout-btn" onClick={handleLogout}>
// //             <span className="logout-icon">🚪</span>
// //             <span className="logout-text">Logout</span>
// //           </button>
// //         </div>
// //       </div>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className={`sidebar-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className={`sidebar ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png" 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>
// //               <nav className="sidebar-nav">
// //                 <a href="#" className="sidebar-link active">
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
// //                 {/* <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">📺</span>
// //                   Live Stream
// //                 </a>
// //                 <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">📄</span>
// //                   Program Outline
// //                 </a> */}
// //                 {/* <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">💬</span>
// //                   Messages
// //                 </a> */}
// //                 {/* <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">👥</span>
// //                   Participants
// //                 </a> */}
// //                 {/* <a href="#" className="sidebar-link">
// //                   <span className="sidebar-icon">⚙️</span>
// //                   Settings
// //                 </a> */}
// //               </nav>
// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className={`welcome-banner ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h2>Welcome back, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h2>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //           <div className="welcome-date">
// //             <span className="date-text">July 2026</span>
// //             <span className="month-text">The Month of Completion</span>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide"
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //               <div className="slide-overlay">
// //                 <div className="slide-content">
// //                   <h3>{sliderImages[currentSlide].title}</h3>
// //                   <p>{sliderImages[currentSlide].subtitle}</p>
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* Live Streaming Section */}
// //       {/* <div className="section-header">
// //         <h2 className="text">📺 Live Streaming</h2>
// //         <a 
// //           href="https://stdl.site/Media/Hyperlink/GLOBAL%20STAFF%20TRAINING/The_Last_Lap_of_Completing_Program_Line_Up_1%20%283%29.docx" 
// //           target="_blank" 
// //           rel="noopener noreferrer"
// //           className="program-outline-link"
// //         >
// //           📄 View Program Outline
// //         </a>
// //       </div> */}

// //       <div className="video-container">
// //         <VideoPlayer />
// //       </div>

// //       {/* Social Actions */}
// //       <div className="social-main">
// //         <div className="social-actions">
// //           <div className="reaction">
// //             <div className="like" onClick={handleToggleLike}>
// //               <span role="img" aria-label="like">
// //                 {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //               </span>
// //               <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //             </div>

// //             <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //               <span role="img" aria-label="comment">💬</span>
// //               <span className="count">{totalComments}</span>
// //               <span className="label">Comments</span>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className={`comments-modal-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 <div className="write">
// //                   <img
// //                     src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png"
// //                     alt="Profile"
// //                   />
// //                   <input
// //                     type="text"
// //                     placeholder="Write a comment..."
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <button onClick={handleCreateComment} disabled={loading}>
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png'} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;


// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
// //   const [isDarkTheme, setIsDarkTheme] = useState(false);
  
// //   const [hasNotifications, setHasNotifications] = useState(true);
// //   const [showNotificationToast, setShowNotificationToast] = useState(false); // NEW STATE FOR UI PROMPT

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';
  
// //   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
// //   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program',
// //       link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide',
// //       link: 'https://anightofathousandcrusades-avatar.stdl.site/' 
// //     },
// //   ];

// //   const trendingVideos = [
// //     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION ', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
// //     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
// //   ];

// //   const trainingVideos = [
// //     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role in Health', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
// //     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
// //   ];

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const toggleTheme = () => {
// //     setIsDarkTheme(!isDarkTheme);
// //     document.body.classList.toggle('dark-theme');
// //   };

// //   // UPDATED NOTIFICATION LOGIC
// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     setShowNotificationToast(true);
// //     // Auto-hide the toast after 3 seconds
// //     setTimeout(() => {
// //       setShowNotificationToast(false);
// //     }, 3000);
// //   };

// //   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

// //   useEffect(() => {
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!numParticipants.trim()) return alert('Please fill in all fields');
// //     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });
// //       setFormSubmitted(true);
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: currentUser?.picturePath },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);
// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   if (!formSubmitted) {
// //     return (
// //       <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={handleFormSubmit} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className={`home-container ${isDarkTheme ? 'dark' : ''}`}>
// //       {/* Top Bar */}
// //       <div className="top-bar">
// //         <div className="top-bar-left">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //         </div>
// //         <div className="top-bar-right">
// //           <button className="theme-toggle" onClick={toggleTheme} title="Toggle Theme">
// //             {isDarkTheme ? '☀️' : '🌙'}
// //           </button>
// //           <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //             {hasNotifications ? (
// //               <>
// //                 <NotificationsIcon className="notification-icon" />
// //                 <span className="notification-badge">3</span>
// //               </>
// //             ) : (
// //               <NotificationsNoneIcon className="notification-icon" />
// //             )}
// //           </button>
// //           <img 
// //             src={currentUser?.picturePath || defaultProfileImg} 
// //             alt="Profile" 
// //             className="topbar-profile-pic"
// //             onClick={() => setIsSidebarOpen(true)}
// //             title="Open Menu"
// //           />
// //         </div>
// //       </div>

// //       {/* NEW: Sleek Notification Toast */}
// //       <AnimatePresence>
// //         {showNotificationToast && (
// //           <motion.div 
// //             className={`notification-toast ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0, y: -20, scale: 0.9 }}
// //             animate={{ opacity: 1, y: 0, scale: 1 }}
// //             exit={{ opacity: 0, y: -20, scale: 0.9 }}
// //             transition={{ type: "spring", stiffness: 300, damping: 25 }}
// //           >
// //             <div className="toast-icon-wrapper">
// //               <NotificationsNoneIcon className="toast-bell-icon" />
// //             </div>
// //             <div className="toast-text">
// //               <h4>No Notifications</h4>
// //               {/* <p>You're all caught up!</p> */}
// //             </div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className={`sidebar-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className={`sidebar ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src={currentUser?.picturePath || defaultProfileImg} 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>
// //               <nav className="sidebar-nav">
// //                 <a 
// //                   href="/" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
// //               </nav>
// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className={`welcome-banner ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h2>Welcome back, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h2>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //           <div className="welcome-date">
// //             <span className="date-text">
// //               {new Date().toLocaleString('default', { month: 'long', year: 'numeric' })}
// //             </span>
// //             <span className="month-text">The Month of Progression</span>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide clickable-slide"
// //               onClick={() => window.open(sliderImages[currentSlide].link, '_blank')}
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* 60/40 Split Layout */}
// //       <div className="main-content-layout">
// //         <div className="left-column">
// //           <div className="video-container">
// //             <VideoPlayer />
// //           </div>
// //           <div className="social-main">
// //             <div className="social-actions">
// //               <div className="reaction">
// //                 <div className="like" onClick={handleToggleLike}>
// //                   <span role="img" aria-label="like">
// //                     {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //                   </span>
// //                   <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //                 </div>

// //                 <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //                   <span role="img" aria-label="comment">💬</span>
// //                   <span className="count">{totalComments}</span>
// //                   <span className="label">Comments</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="right-column">
// //           <div className="recommended-videos">
// //             <h4>Trending Videos</h4>
// //             <div className="video-list">
// //               {trendingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     {/* <span className="duration">{vid.duration}</span> */}
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>

// //             <h4 className="mt-4"> Training Videos</h4>
// //             <div className="video-list">
// //               {trainingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     <span className="duration">{vid.duration}</span>
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className={`comments-modal-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 <div className="write">
// //                   <img
// //                     src={currentUser?.picturePath || defaultProfileImg}
// //                     alt="Profile"
// //                   />
// //                   <input
// //                     type="text"
// //                     placeholder="Write a comment..."
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <button onClick={handleCreateComment} disabled={loading}>
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || defaultProfileImg} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;


// //Dashboard



// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  
// //   // CHANGED: Default is now true so the sleek blue is the default background
// //   const [isDarkTheme, setIsDarkTheme] = useState(true);
  
// //   const [hasNotifications, setHasNotifications] = useState(true);
// //   const [showNotificationToast, setShowNotificationToast] = useState(false);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';
  
// //   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
// //   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program',
// //       link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide',
// //       link: 'https://anightofathousandcrusades-avatar.stdl.site/' 
// //     },
// //   ];

// //   const trendingVideos = [
// //     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION ', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
// //     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
// //   ];

// //   const trainingVideos = [
// //     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role in Health', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
// //     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
// //   ];

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const toggleTheme = () => {
// //     setIsDarkTheme(!isDarkTheme);
// //     document.body.classList.toggle('dark-theme');
// //   };

// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     setShowNotificationToast(true);
// //     setTimeout(() => {
// //       setShowNotificationToast(false);
// //     }, 3000);
// //   };

// //   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

// //   useEffect(() => {
// //     // Force the body to match the blue default theme on load
// //     document.body.classList.add('dark-theme');
    
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!numParticipants.trim()) return alert('Please fill in all fields');
// //     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });
// //       setFormSubmitted(true);
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: currentUser?.picturePath },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);
// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   if (!formSubmitted) {
// //     return (
// //       <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={handleFormSubmit} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className={`home-container ${isDarkTheme ? 'dark' : ''}`}>
      
// //       {/* NEW: Scrolling Ticker at the top */}


// //       {/* Top Bar */}
// //       <div className="top-bar">
// //         <div className="top-bar-left">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //         </div>
// //         <div className="top-bar-right">
// //           <button className="theme-toggle" onClick={toggleTheme} title="Toggle Theme">
// //             {isDarkTheme ? '☀️' : '🌙'}
// //           </button>
// //           <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //             {hasNotifications ? (
// //               <>
// //                 <NotificationsIcon className="notification-icon" />
// //                 <span className="notification-badge">3</span>
// //               </>
// //             ) : (
// //               <NotificationsNoneIcon className="notification-icon" />
// //             )}
// //           </button>
// //           <img 
// //             src={currentUser?.picturePath || defaultProfileImg} 
// //             alt="Profile" 
// //             className="topbar-profile-pic"
// //             onClick={() => setIsSidebarOpen(true)}
// //             title="Open Menu"
// //           />
// //         </div>
// //       </div>
// //       <div className="scrolling-ticker">
// //         <div className="ticker-text">
// //           🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression!
// //         </div>
// //       </div>
// //       {/* Sleek Notification Toast */}
// //       <AnimatePresence>
// //         {showNotificationToast && (
// //           <motion.div 
// //             className={`notification-toast ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0, y: -20, scale: 0.9 }}
// //             animate={{ opacity: 1, y: 0, scale: 1 }}
// //             exit={{ opacity: 0, y: -20, scale: 0.9 }}
// //             transition={{ type: "spring", stiffness: 300, damping: 25 }}
// //           >
// //             <div className="toast-icon-wrapper">
// //               <NotificationsNoneIcon className="toast-bell-icon" />
// //             </div>
// //             <div className="toast-text">
// //               <h4>No Notifications</h4>
// //               <p>You're all caught up!</p>
// //             </div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className={`sidebar-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className={`sidebar ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src={currentUser?.picturePath || defaultProfileImg} 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>
// //               <nav className="sidebar-nav">
// //                 <a 
// //                   href="/" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
// //               </nav>
// //                             <nav className="sidebar-nav">
// //                 <a 
// //                   href="/life" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/life');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Life in the Kingdo
// //                 </a>
// //               </nav>
// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className={`welcome-banner ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h3>Welcome, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h3>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //           {/* Removed the date here since it is now in the scrolling ticker */}
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide clickable-slide"
// //               onClick={() => window.open(sliderImages[currentSlide].link, '_blank')}
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* 60/40 Split Layout */}
// //       <div className="main-content-layout">
// //         <div className="left-column">
// //           <div className="video-container">
// //             <VideoPlayer />
// //           </div>
// //           <div className="social-main">
// //             <div className="social-actions">
// //               <div className="reaction">
// //                 <div className="like" onClick={handleToggleLike}>
// //                   <span role="img" aria-label="like">
// //                     {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //                   </span>
// //                   <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //                 </div>

// //                 <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //                   <span role="img" aria-label="comment">💬</span>
// //                   <span className="count">{totalComments}</span>
// //                   <span className="label">Comments</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="right-column">
// //           <div className="recommended-videos">
// //             <h4>🔥 Trending Videos</h4>
// //             <div className="video-list">
// //               {trendingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     {/* <span className="duration">{vid.duration}</span> */}
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>

// //             <h4 className="mt-4">📚 Training Videos</h4>
// //             <div className="video-list">
// //               {trainingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     <span className="duration">{vid.duration}</span>
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className={`comments-modal-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 <div className="write">
// //                   <img
// //                     src={currentUser?.picturePath || defaultProfileImg}
// //                     alt="Profile"
// //                   />
// //                   <input
// //                     type="text"
// //                     placeholder="Write a comment..."
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <button onClick={handleCreateComment} disabled={loading}>
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || defaultProfileImg} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;



// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  
// //   const [isDarkTheme, setIsDarkTheme] = useState(true);
  
// //   const [hasNotifications, setHasNotifications] = useState(true);
// //   const [showNotificationToast, setShowNotificationToast] = useState(false);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';
  
// //   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
// //   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program',
// //       link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide',
// //       link: 'https://anightofathousandcrusades-avatar.stdl.site/' 
// //     },
// //   ];

// //   const trendingVideos = [
// //     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION ', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
// //     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
// //   ];

// //   const trainingVideos = [
// //     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role in Health', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
// //     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
// //   ];

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const toggleTheme = () => {
// //     setIsDarkTheme(!isDarkTheme);
// //     document.body.classList.toggle('dark-theme');
// //   };

// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     setShowNotificationToast(true);
// //     setTimeout(() => {
// //       setShowNotificationToast(false);
// //     }, 3000);
// //   };

// //   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

// //   useEffect(() => {
// //     document.body.classList.add('dark-theme');
    
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!numParticipants.trim()) return alert('Please fill in all fields');
// //     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });
// //       setFormSubmitted(true);
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: currentUser?.picturePath },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);
// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   if (!formSubmitted) {
// //     return (
// //       <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={handleFormSubmit} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className={`home-container ${isDarkTheme ? 'dark' : ''}`}>
      
// //       {/* Top Bar */}
// //       <div className="top-bar">
// //         <div className="top-bar-left">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //         </div>
// //         <div className="top-bar-right">
// //           <button className="theme-toggle" onClick={toggleTheme} title="Toggle Theme">
// //             {isDarkTheme ? '☀️' : '🌙'}
// //           </button>
// //           <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //             {hasNotifications ? (
// //               <>
// //                 <NotificationsIcon className="notification-icon" />
// //                 <span className="notification-badge">3</span>
// //               </>
// //             ) : (
// //               <NotificationsNoneIcon className="notification-icon" />
// //             )}
// //           </button>
// //           <img 
// //             src={currentUser?.picturePath || defaultProfileImg} 
// //             alt="Profile" 
// //             className="topbar-profile-pic"
// //             onClick={() => setIsSidebarOpen(true)}
// //             title="Open Menu"
// //           />
// //         </div>
// //       </div>
// //       <div className="scrolling-ticker">
// //         <div className="ticker-text">
// //           🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression!
// //         </div>
// //       </div>

// //       {/* Sleek Notification Toast */}
// //       <AnimatePresence>
// //         {showNotificationToast && (
// //           <motion.div 
// //             className={`notification-toast ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0, y: -20, scale: 0.9 }}
// //             animate={{ opacity: 1, y: 0, scale: 1 }}
// //             exit={{ opacity: 0, y: -20, scale: 0.9 }}
// //             transition={{ type: "spring", stiffness: 300, damping: 25 }}
// //           >
// //             <div className="toast-icon-wrapper">
// //               <NotificationsNoneIcon className="toast-bell-icon" />
// //             </div>
// //             <div className="toast-text">
// //               <h4>No Notifications</h4>
// //               <p>You're all caught up!</p>
// //             </div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className={`sidebar-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className={`sidebar ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src={currentUser?.picturePath || defaultProfileImg} 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* COMBINED NAV LINKS */}
// //               <nav className="sidebar-nav">
// //                 <a 
// //                   href="/" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
                
// //                 <a 
// //                   href="/life" 
// //                   className="sidebar-link"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/life');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">👑</span>
// //                   Life in the Kingdom
// //                 </a>
// //               </nav>

// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className={`welcome-banner ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h3>Welcome, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h3>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide clickable-slide"
// //               onClick={() => window.open(sliderImages[currentSlide].link, '_blank')}
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* 60/40 Split Layout */}
// //       <div className="main-content-layout">
// //         <div className="left-column">
// //           <div className="video-container">
// //             <VideoPlayer />
// //           </div>
// //           <div className="social-main">
// //             <div className="social-actions">
// //               <div className="reaction">
// //                 <div className="like" onClick={handleToggleLike}>
// //                   <span role="img" aria-label="like">
// //                     {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //                   </span>
// //                   <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //                 </div>

// //                 <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //                   <span role="img" aria-label="comment">💬</span>
// //                   <span className="count">{totalComments}</span>
// //                   <span className="label">Comments</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="right-column">
// //           <div className="recommended-videos">
// //             <h4>🔥 Trending Videos</h4>
// //             <div className="video-list">
// //               {trendingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>

// //             <h4 className="mt-4">📚 Training Videos</h4>
// //             <div className="video-list">
// //               {trainingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     <span className="duration">{vid.duration}</span>
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className={`comments-modal-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 <div className="write">
// //                   <img
// //                     src={currentUser?.picturePath || defaultProfileImg}
// //                     alt="Profile"
// //                   />
// //                   <input
// //                     type="text"
// //                     placeholder="Write a comment..."
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <button onClick={handleCreateComment} disabled={loading}>
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || defaultProfileImg} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;



// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  
// //   const [isDarkTheme, setIsDarkTheme] = useState(true);
  
// //   const [hasNotifications, setHasNotifications] = useState(true);
// //   const [showNotificationToast, setShowNotificationToast] = useState(false);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';
  
// //   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
// //   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program',
// //       link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide',
// //       link: 'https://anightofathousandcrusades-avatar.stdl.site/' 
// //     },
// //   ];

// //   const trendingVideos = [
// //     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION ', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
// //     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
// //   ];

// //   const trainingVideos = [
// //     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role in Health', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
// //     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
// //   ];

// //   // ==========================================
// //   // NEW: CHECK LOCAL STORAGE ON MOUNT
// //   // ==========================================
// //   useEffect(() => {
// //     if (currentUser?.portalID) {
// //       // Check if this specific user has already submitted the form on this device
// //       const hasSubmitted = localStorage.getItem(`participation_submitted_${currentUser.portalID}`);
// //       if (hasSubmitted === 'true') {
// //         setFormSubmitted(true);
// //       }
// //     }
// //   }, [currentUser]);

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const toggleTheme = () => {
// //     setIsDarkTheme(!isDarkTheme);
// //     document.body.classList.toggle('dark-theme');
// //   };

// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     setShowNotificationToast(true);
// //     setTimeout(() => {
// //       setShowNotificationToast(false);
// //     }, 3000);
// //   };

// //   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

// //   useEffect(() => {
// //     document.body.classList.add('dark-theme');
    
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!numParticipants.trim()) return alert('Please fill in all fields');
// //     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });
      
// //       // ==========================================
// //       // NEW: SAVE SUCCESS TO LOCAL STORAGE
// //       // ==========================================
// //       if (currentUser?.portalID) {
// //         localStorage.setItem(`participation_submitted_${currentUser.portalID}`, 'true');
// //       }
      
// //       setFormSubmitted(true);
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: currentUser?.picturePath },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);
// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   if (!formSubmitted) {
// //     return (
// //       <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={handleFormSubmit} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className={`home-container ${isDarkTheme ? 'dark' : ''}`}>
      
// //       {/* Top Bar */}
// //       <div className="top-bar">
// //         <div className="top-bar-left">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //         </div>
// //         <div className="top-bar-right">
// //           <button className="theme-toggle" onClick={toggleTheme} title="Toggle Theme">
// //             {isDarkTheme ? '☀️' : '🌙'}
// //           </button>
// //           <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //             {hasNotifications ? (
// //               <>
// //                 <NotificationsIcon className="notification-icon" />
// //                 <span className="notification-badge">3</span>
// //               </>
// //             ) : (
// //               <NotificationsNoneIcon className="notification-icon" />
// //             )}
// //           </button>
// //           <img 
// //             src={currentUser?.picturePath || defaultProfileImg} 
// //             alt="Profile" 
// //             className="topbar-profile-pic"
// //             onClick={() => setIsSidebarOpen(true)}
// //             title="Open Menu"
// //           />
// //         </div>
// //       </div>
// //       <div className="scrolling-ticker">
// //         <div className="ticker-text">
// //           🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression!
// //         </div>
// //       </div>

// //       {/* Sleek Notification Toast */}
// //       <AnimatePresence>
// //         {showNotificationToast && (
// //           <motion.div 
// //             className={`notification-toast ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0, y: -20, scale: 0.9 }}
// //             animate={{ opacity: 1, y: 0, scale: 1 }}
// //             exit={{ opacity: 0, y: -20, scale: 0.9 }}
// //             transition={{ type: "spring", stiffness: 300, damping: 25 }}
// //           >
// //             <div className="toast-icon-wrapper">
// //               <NotificationsNoneIcon className="toast-bell-icon" />
// //             </div>
// //             <div className="toast-text">
// //               <h4>No Notifications</h4>
// //               <p>You're all caught up!</p>
// //             </div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className={`sidebar-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className={`sidebar ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src={currentUser?.picturePath || defaultProfileImg} 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* COMBINED NAV LINKS */}
// //               <nav className="sidebar-nav">
// //                 <a 
// //                   href="/" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
                
// //                 <a 
// //                   href="/life" 
// //                   className="sidebar-link"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/life');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">👑</span>
// //                   Life in the Kingdom
// //                 </a>
// //               </nav>

// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className={`welcome-banner ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h3>Welcome, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h3>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide clickable-slide"
// //               onClick={() => window.open(sliderImages[currentSlide].link, '_blank')}
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* 60/40 Split Layout */}
// //       <div className="main-content-layout">
// //         <div className="left-column">
// //           <div className="video-container">
// //             <VideoPlayer />
// //           </div>
// //           <div className="social-main">
// //             <div className="social-actions">
// //               <div className="reaction">
// //                 <div className="like" onClick={handleToggleLike}>
// //                   <span role="img" aria-label="like">
// //                     {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //                   </span>
// //                   <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //                 </div>

// //                 <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //                   <span role="img" aria-label="comment">💬</span>
// //                   <span className="count">{totalComments}</span>
// //                   <span className="label">Comments</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="right-column">
// //           <div className="recommended-videos">
// //             <h4>🔥 Trending Videos</h4>
// //             <div className="video-list">
// //               {trendingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>

// //             <h4 className="mt-4">📚 Training Videos</h4>
// //             <div className="video-list">
// //               {trainingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     <span className="duration">{vid.duration}</span>
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className={`comments-modal-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 <div className="write">
// //                   <img
// //                     src={currentUser?.picturePath || defaultProfileImg}
// //                     alt="Profile"
// //                   />
// //                   <input
// //                     type="text"
// //                     placeholder="Write a comment..."
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <button onClick={handleCreateComment} disabled={loading}>
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || defaultProfileImg} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;





// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
// // // 60
// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  
// //   const [isDarkTheme, setIsDarkTheme] = useState(true);
  
// //   const [hasNotifications, setHasNotifications] = useState(true);
// //   const [showNotificationToast, setShowNotificationToast] = useState(false);

// //   // Initial Form State
// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   // 45-Minute Periodic Prompt State
// //   const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
// //   const [isUpdatingParticipation, setIsUpdatingParticipation] = useState(false);

// //   // Comments & Social State
// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';
  
// //   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
// //   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program',
// //       link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide',
// //       link: 'https://anightofathousandcrusades-avatar.stdl.site/' 
// //     },
// //   ];

// //   const trendingVideos = [
// //     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION ', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
// //     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
// //   ];

// //   const trainingVideos = [
// //     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role in Health', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
// //     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
// //   ];
// // //It's been a while! 
// //   // ==========================================
// //   // PERIODIC 45 MINUTE PROMPT LOGIC
// //   // ==========================================
// //   useEffect(() => {
// //     // 45 minutes = 45 * 60 * 1000 = 2,700,000 milliseconds
// //     const promptInterval = setInterval(() => {
// //       setShowUpdatePrompt(true);
// //     }, 2700000); 

// //     return () => clearInterval(promptInterval);
// //   }, []);

// //   // Check local storage for initial participation state
// //   useEffect(() => {
// //     if (currentUser?.portalID) {
// //       const hasSubmitted = localStorage.getItem(`participation_submitted_${currentUser.portalID}`);
// //       if (hasSubmitted === 'true') {
// //         setFormSubmitted(true);
// //       }
// //     }
// //   }, [currentUser]);

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const toggleTheme = () => {
// //     setIsDarkTheme(!isDarkTheme);
// //     document.body.classList.toggle('dark-theme');
// //   };

// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     setShowNotificationToast(true);
// //     setTimeout(() => {
// //       setShowNotificationToast(false);
// //     }, 3000);
// //   };

// //   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

// //   useEffect(() => {
// //     document.body.classList.add('dark-theme');
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e, isUpdate = false) => {
// //     e.preventDefault();
// //     if (!numParticipants.trim()) return alert('Please fill in all fields');
// //     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });
      
// //       if (currentUser?.portalID) {
// //         localStorage.setItem(`participation_submitted_${currentUser.portalID}`, 'true');
// //       }
      
// //       if (isUpdate) {
// //         setIsUpdatingParticipation(false);
// //         setNumParticipants(''); // Clear input for next time
// //       } else {
// //         setFormSubmitted(true);
// //       }
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: currentUser?.picturePath },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);
// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   // Initial Full Screen Participation Form
// //   if (!formSubmitted) {
// //     return (
// //       <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="form-header">
// //           <h2 className="form-title">🎯 Participation Form</h2>
// //           <p className="form-subtitle">Please confirm your attendance</p>
// //         </div>
// //         <form onSubmit={(e) => handleFormSubmit(e, false)} className="participation-form">
// //           <div className="form-group">
// //             <label>Number of Participants</label>
// //             <input
// //               type="number"
// //               value={numParticipants}
// //               onChange={(e) => setNumParticipants(e.target.value)}
// //               placeholder="Enter number of participants"
// //               min="1"
// //               required
// //             />
// //           </div>
// //           <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //             {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //           </button>
// //         </form>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className={`home-container ${isDarkTheme ? 'dark' : ''}`}>
      
// //       {/* Top Bar */}
// //       <div className="top-bar">
//         // <div className="top-bar-left">
//         //   <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
//         //     <span className="hamburger-icon">☰</span>
//         //   </button>
//         // </div>
// //         <div className="top-bar-right">
// //           <button className="theme-toggle" onClick={toggleTheme} title="Toggle Theme">
// //             {isDarkTheme ? '☀️' : '🌙'}
// //           </button>
// //           <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //             {hasNotifications ? (
// //               <>
// //                 <NotificationsIcon className="notification-icon" />
// //                 <span className="notification-badge">3</span>
// //               </>
// //             ) : (
// //               <NotificationsNoneIcon className="notification-icon" />
// //             )}
// //           </button>
// //           <img 
// //             src={currentUser?.picturePath || defaultProfileImg} 
// //             alt="Profile" 
// //             className="topbar-profile-pic"
// //             onClick={() => setIsSidebarOpen(true)}
// //             title="Open Menu"
// //           />
// //         </div>
// //       </div>
// //       <div className="scrolling-ticker">
// //         <div className="ticker-text">
// //           🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression!
// //         </div>
// //       </div>

// //       {/* Sleek Notification Toast */}
// //       <AnimatePresence>
// //         {showNotificationToast && (
// //           <motion.div 
// //             className={`notification-toast ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0, y: -20, scale: 0.9 }}
// //             animate={{ opacity: 1, y: 0, scale: 1 }}
// //             exit={{ opacity: 0, y: -20, scale: 0.9 }}
// //             transition={{ type: "spring", stiffness: 300, damping: 25 }}
// //           >
// //             <div className="toast-icon-wrapper">
// //               <NotificationsNoneIcon className="toast-bell-icon" />
// //             </div>
// //             <div className="toast-text">
// //               <h4>No Notifications</h4>
// //               <p>You're all caught up!</p>
// //             </div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* =========================================
// //           NEW: 45 MINUTE PROMPT MODALS
// //           ========================================= */}
      
// //       {/* 1. The Prompt asking "Do you want to update?" */}
// //       <AnimatePresence>
// //         {showUpdatePrompt && (
// //           <motion.div 
// //             className="comments-modal-overlay active"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               style={{ maxWidth: '400px', padding: '2rem', textAlign: 'center' }}
// //             >
// //               <h2 style={{ marginBottom: '1rem', color: isDarkTheme ? '#e8edf3' : '#1a1a2e' }}>Update Attendance?</h2>
// //               <p style={{ color: '#8a9ab0', marginBottom: '2rem', lineHeight: '1.5' }}>
// //                 Are more people watching with you now? Would you like to update your participant count?
// //               </p>
// //               <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
// //                 <button 
// //                   className="modal-close-btn" 
// //                   style={{ background: '#2a3a5e', color: '#fff', padding: '0.8rem 1.5rem', borderRadius: '8px', cursor: 'pointer', border: 'none' }}
// //                   onClick={() => setShowUpdatePrompt(false)}
// //                 >
// //                   Not Now
// //                 </button>
// //                 <button 
// //                   style={{ background: 'linear-gradient(135deg, #4a6fa5, #6c5ce7)', color: '#fff', padding: '0.8rem 1.5rem', borderRadius: '8px', cursor: 'pointer', border: 'none', fontWeight: 'bold' }}
// //                   onClick={() => {
// //                     setShowUpdatePrompt(false);
// //                     setIsUpdatingParticipation(true);
// //                   }}
// //                 >
// //                   Yes, Update
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* 2. The Form Modal if they click "Yes, Update" */}
// //       <AnimatePresence>
// //         {isUpdatingParticipation && (
// //           <motion.div 
// //             className="comments-modal-overlay active"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //           >
// //             <motion.div 
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //             >
// //               <div className={`participation-form-container ${isDarkTheme ? 'dark' : ''}`} style={{ margin: 0, position: 'relative' }}>
                
// //                 <button className="modal-close-btn" onClick={() => setIsUpdatingParticipation(false)} style={{ position: 'absolute', top: '15px', right: '15px' }}>
// //                   <CloseIcon />
// //                 </button>

// //                 <div className="form-header">
// //                   <h2 className="form-title">🎯 Update Participation</h2>
// //                   <p className="form-subtitle">Add your new current total of participants</p>
// //                 </div>
// //                 <form onSubmit={(e) => handleFormSubmit(e, true)} className="participation-form">
// //                   <div className="form-group">
// //                     <label>Total Number of Participants</label>
// //                     <input
// //                       type="number"
// //                       value={numParticipants}
// //                       onChange={(e) => setNumParticipants(e.target.value)}
// //                       placeholder="Enter new total number"
// //                       min="1"
// //                       required
// //                     />
// //                   </div>
// //                   <button type="submit" disabled={loadingForm} className="form-submit-btn">
// //                     {loadingForm ? 'Updating...' : 'Update Records →'}
// //                   </button>
// //                 </form>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className={`sidebar-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className={`sidebar ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src={currentUser?.picturePath || defaultProfileImg} 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name">{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role">{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>

// //               <nav className="sidebar-nav">
// //                 <a 
// //                   href="/" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
                
// //                 <a 
// //                   href="/lndkingdom" 
// //                   className="sidebar-link"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/lndkingdom');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">👑</span>
// //                   Life in the Kingdom
// //                 </a>
// //               </nav>

// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Welcome Banner */}
// //       <div className={`welcome-banner ${isDarkTheme ? 'dark' : ''}`}>
// //         <div className="welcome-content">
// //           <div className="welcome-text">
// //             <h3>Welcome, <span className="highlight-name">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h3>
// //             <p className="welcome-location">📍 Loveworld Staff Development Centre</p>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Slider Banner */}
// //       <div className="slider-container">
// //         <div className="slider-wrapper">
// //           <AnimatePresence mode='wait'>
// //             <motion.div 
// //               key={currentSlide}
// //               className="slide clickable-slide"
// //               onClick={() => window.open(sliderImages[currentSlide].link, '_blank')}
// //               initial={{ opacity: 0, scale: 0.95 }}
// //               animate={{ opacity: 1, scale: 1 }}
// //               exit={{ opacity: 0, scale: 0.95 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <img 
// //                 src={sliderImages[currentSlide].url} 
// //                 alt={sliderImages[currentSlide].title}
// //                 className="slide-image"
// //               />
// //             </motion.div>
// //           </AnimatePresence>
          
// //           <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //           <button className="slider-btn next" onClick={nextSlide}>❯</button>
          
// //           <div className="slider-dots">
// //             {sliderImages.map((_, index) => (
// //               <span 
// //                 key={index} 
// //                 className={`dot ${index === currentSlide ? 'active' : ''}`}
// //                 onClick={() => setCurrentSlide(index)}
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* 60/40 Split Layout */}
// //       <div className="main-content-layout">
// //         <div className="left-column">
// //           <div className="video-container">
// //             <VideoPlayer />
// //           </div>
// //           <div className="social-main">
// //             <div className="social-actions">
// //               <div className="reaction">
// //                 <div className="like" onClick={handleToggleLike}>
// //                   <span role="img" aria-label="like">
// //                     {liked ? <FavoriteOutlinedIcon className="liked" /> : <FavoriteBorderOutlinedIcon />}
// //                   </span>
// //                   <span className="count">{totalLikes !== null ? totalLikes : 0}</span>
// //                 </div>

// //                 <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)}>
// //                   <span role="img" aria-label="comment">💬</span>
// //                   <span className="count">{totalComments}</span>
// //                   <span className="label">Comments</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="right-column">
// //           <div className="recommended-videos">
// //             <h4>🔥 Trending Videos</h4>
// //             <div className="video-list">
// //               {trendingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>

// //             <h4 className="mt-4">📚 Training Videos</h4>
// //             <div className="video-list">
// //               {trainingVideos.map(vid => (
// //                 <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')}>
// //                   <div className="thumb-container">
// //                     <img src={vid.thumb} alt={vid.title} />
// //                     <span className="duration">{vid.duration}</span>
// //                   </div>
// //                   <div className="vid-details">
// //                     <p>{vid.title}</p>
// //                     <span className="vid-action">Get App to Watch →</span>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Comments Modal */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className={`comments-modal-overlay ${isDarkTheme ? 'dark' : ''}`}
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className={`comments-modal ${isDarkTheme ? 'dark' : ''}`}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="comments-modal-header">
// //                 <h2>💬 Comments</h2>
// //                 <button className="modal-close-btn" onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div className="comments-modal-body">
// //                 {/* RESTRUCTURED FOR MOBILE FLEXIBILITY */}
// //                 <div className="write">
// //                   <div className="write-input-group">
// //                     <img
// //                       src={currentUser?.picturePath || defaultProfileImg}
// //                       alt="Profile"
// //                     />
// //                     <input
// //                       type="text"
// //                       placeholder="Write a comment..."
// //                       value={newComment}
// //                       onChange={(e) => setNewComment(e.target.value)}
// //                     />
// //                   </div>
// //                   <button onClick={handleCreateComment} disabled={loading} className="send-comment-btn">
// //                     {loading ? 'Sending...' : 'Send'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list">
// //                   {comments.length === 0 ? (
// //                     <div className="no-comments">
// //                       <span>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id}>
// //                         <img src={comment.picture?.uri || defaultProfileImg} alt="" />
// //                         <div className="info">
// //                           <div className="comment-header">
// //                             <span className="name">{comment.name}</span>
// //                             <span className="department">{comment.department}</span>
// //                           </div>
// //                           <p className="msg">{comment.text}</p>
// //                           <span className="date">
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;




// // import React, { useState, useEffect, useContext } from 'react';
// // import './Home.css';
// // import { AuthContext } from '../../context/authContext';
// // import axios from 'axios';
// // import { useNavigate } from 'react-router-dom';
// // import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// // import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// // import VideoPlayer from './Videoplayer';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import CloseIcon from '@mui/icons-material/Close';
// // import NotificationsIcon from '@mui/icons-material/Notifications';
// // import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// // const Home = () => {
// //   const navigate = useNavigate();
// //   const { currentUser, logout } = useContext(AuthContext);
  
// //   // Layout & UI State
// //   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// //   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
// //   const [isScrolled, setIsScrolled] = useState(false);
// //   const [hasNotifications, setHasNotifications] = useState(true);
// //   const [showNotificationToast, setShowNotificationToast] = useState(false);

// //   // Initial Form State
// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [numParticipants, setNumParticipants] = useState('');
// //   const [loadingForm, setLoadingForm] = useState(false);

// //   // 45-Minute Periodic Prompt State
// //   const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
// //   const [isUpdatingParticipation, setIsUpdatingParticipation] = useState(false);

// //   // Comments & Social State
// //   const [newComment, setNewComment] = useState('');
// //   const [comments, setComments] = useState([]);
// //   const [totalLikes, setTotalLikes] = useState(null);
// //   const [totalComments, setTotalComments] = useState(0);
// //   const [liked, setLiked] = useState(false);
// //   const [loading, setLoading] = useState(false);
  
// //   const [currentSlide, setCurrentSlide] = useState(0);
  
// //   const API_BASE_URL = 'https://api.stdl.site';
// //   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
// //   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

// //   const sliderImages = [
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/c2puTFJ5MVVtWWc3aGtUS01wb1FwQT09/newww_222.png',
// //       title: 'Global Staff Training',
// //       subtitle: 'The Last Lap of Completing Program',
// //       link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
// //     },
// //     {
// //       url: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/L0dOWnRnZEhHcFpYUzI2ekY5SFRrdz09/1001340677.jpg',
// //       title: 'Staff Development Centre',
// //       subtitle: 'Empowering Leaders Worldwide',
// //       link: 'https://anightofathousandcrusades-avatar.stdl.site/' 
// //     },
// //   ];

// //   const trendingVideos = [
// //     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
// //     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
// //   ];

// //   const trainingVideos = [
// //     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
// //     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
// //   ];

// //   // ==========================================
// //   // SCROLL & PERIODIC PROMPT LOGIC
// //   // ==========================================
// //   useEffect(() => {
// //     const handleScroll = () => setIsScrolled(window.scrollY > 40);
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   useEffect(() => {
// //     const promptInterval = setInterval(() => {
// //       setShowUpdatePrompt(true);
// //     }, 2700000); // 45 mins
// //     return () => clearInterval(promptInterval);
// //   }, []);

// //   useEffect(() => {
// //     if (currentUser?.portalID) {
// //       const hasSubmitted = localStorage.getItem(`participation_submitted_${currentUser.portalID}`);
// //       if (hasSubmitted === 'true') {
// //         setFormSubmitted(true);
// //       }
// //     }
// //   }, [currentUser]);

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const handleNotificationClick = () => {
// //     setHasNotifications(false);
// //     setShowNotificationToast(true);
// //     setTimeout(() => setShowNotificationToast(false), 3000);
// //   };

// //   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
// //   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

// //   useEffect(() => {
// //     document.body.classList.add('dark-theme');
// //     const timer = setInterval(nextSlide, 5000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   const handleFormSubmit = async (e, isUpdate = false) => {
// //     e.preventDefault();
// //     if (!numParticipants.trim()) return alert('Please fill in all fields');
// //     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

// //     try {
// //       setLoadingForm(true);
// //       await axios.post(`${API_BASE_URL}/participation`, {
// //         userId: currentUser?.portalID,
// //         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
// //         department: currentUser?.deptName,
// //         participants: numParticipants,
// //       });
      
// //       if (currentUser?.portalID) {
// //         localStorage.setItem(`participation_submitted_${currentUser.portalID}`, 'true');
// //       }
      
// //       if (isUpdate) {
// //         setIsUpdatingParticipation(false);
// //         setNumParticipants(''); 
// //       } else {
// //         setFormSubmitted(true);
// //       }
// //     } catch (error) {
// //       console.error("Error submitting participation form:", error);
// //       alert("There was an issue submitting the form. Try again.");
// //     } finally {
// //       setLoadingForm(false);
// //     }
// //   };

// //   const fetchComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments`);
// //       setComments(res.data.comments);
// //     } catch (error) {
// //       console.error("Error fetching comments:", error);
// //     }
// //   };

// //   const fetchTotalComments = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
// //       setTotalComments(res.data.totalComments);
// //     } catch (error) {
// //       console.error("Error fetching total comments:", error);
// //     }
// //   };

// //   const fetchTotalLikes = async () => {
// //     try {
// //       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
// //       setTotalLikes(res.data.totalLikes);
// //     } catch (error) {
// //       console.error("Error fetching total likes:", error);
// //     }
// //   };

// //   const handleToggleLike = async () => {
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
// //       setLiked(res.data.liked);
// //       fetchTotalLikes();
// //     } catch (error) {
// //       console.error("Error toggling like:", error);
// //     }
// //   };

// //   const handleCreateComment = async () => {
// //     if (newComment.trim() === "") return;
// //     setLoading(true);
// //     try {
// //       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
// //         userId: currentUser?.portalID,
// //         text: newComment,
// //         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
// //         picture: { uri: currentUser?.picturePath },
// //         department: currentUser.deptName,
// //       });
// //       setComments([res.data.comment, ...comments]);
// //       setNewComment("");
// //       setTotalComments(totalComments + 1);
// //     } catch (error) {
// //       console.error("Error creating comment:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (formSubmitted) {
// //       fetchComments();
// //       fetchTotalLikes();
// //       fetchTotalComments();

// //       const intervalId = setInterval(() => {
// //         fetchComments();
// //         fetchTotalLikes();
// //         fetchTotalComments();
// //       }, 10000);
// //       return () => clearInterval(intervalId);
// //     }
// //   }, [formSubmitted, currentUser?.portalID]);

// //   // Initial Full Screen Participation Form
// //   if (!formSubmitted) {
// //     return (
// //       <div className="app-container">
// //         <div className="bg-glow glow-1"></div>
// //         <div className="bg-glow glow-3"></div>
        
// //         <div className="participation-form-container glass-card" style={{ maxWidth: '500px', margin: '100px auto', zIndex: 10, position: 'relative' }}>
// //           <div className="form-header">
// //             <h2 className="section-title" style={{ fontSize: '2rem' }}>🎯 Registration</h2>
// //             <p className="section-subtitle">Please confirm your attendance</p>
// //           </div>
// //           <form onSubmit={(e) => handleFormSubmit(e, false)} className="participation-form">
// //             <div className="form-group" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
// //               <label style={{ color: '#F8FAFC', marginBottom: '8px', display: 'block' }}>Number of Participants</label>
// //               <input
// //                 type="number"
// //                 value={numParticipants}
// //                 onChange={(e) => setNumParticipants(e.target.value)}
// //                 placeholder="Enter number of participants"
// //                 min="1"
// //                 required
// //                 style={{ width: '100%', padding: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px' }}
// //               />
// //             </div>
// //             <button type="submit" disabled={loadingForm} className="btn btn-primary btn-full" style={{ padding: '16px' }}>
// //               {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
// //             </button>
// //           </form>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="app-container">
      
// //       {/* Background Ambient Glows */}
// //       <div className="bg-glow glow-1"></div>
// //       <div className="bg-glow glow-2"></div>
// //       <div className="bg-glow glow-3"></div>

// //       {/* Scrolling Ticker */}
// //       <div className="scrolling-ticker">
// //         <div className="ticker-text">
// //           🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression! Explore the latest training content now.
// //         </div>
// //       </div>

// //       {/* Sleek Navigation Bar */}
// //       <header className={`navbar-container ${isScrolled ? 'scrolled' : ''}`} style={{ top: '38px' }}>
// //         <nav className="navbar max-width">

// //           <div className="logo-group">
// //           <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
// //             <span className="hamburger-icon">☰</span>
// //           </button>
// //             <div className="logo-badge">STDL</div>
// //             <div className="brand-text">
// //               <span className="brand-title">Dashboard</span>
// //               <span className="brand-sub">FOR STAFF</span>
// //             </div>
// //           </div>

// //           <div className="nav-actions">
// //             <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
// //               {hasNotifications ? (
// //                 <>
// //                   <NotificationsIcon className="notification-icon" />
// //                   <span className="notification-badge">3</span>
// //                 </>
// //               ) : (
// //                 <NotificationsNoneIcon className="notification-icon" />
// //               )}
// //             </button>
// //             <img 
// //               src={currentUser?.picturePath || defaultProfileImg} 
// //               alt="Profile" 
// //               className="topbar-profile-pic"
// //               onClick={() => setIsSidebarOpen(true)}
// //             />
// //           </div>
// //         </nav>
// //       </header>

// //       {/* Sleek Notification Toast */}
// //       <AnimatePresence>
// //         {showNotificationToast && (
// //           <motion.div 
// //             className="notification-toast glass-card"
// //             initial={{ opacity: 0, y: -20, scale: 0.9 }}
// //             animate={{ opacity: 1, y: 0, scale: 1 }}
// //             exit={{ opacity: 0, y: -20, scale: 0.9 }}
// //             transition={{ type: "spring", stiffness: 300, damping: 25 }}
// //           >
// //             <div className="toast-icon-wrapper bg-purple-glow">
// //               <NotificationsNoneIcon className="toast-bell-icon" />
// //             </div>
// //             <div className="toast-text">
// //               <h4>No Notifications</h4>
// //               <p>You're all caught up!</p>
// //             </div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* =========================================
// //           NEW: 45 MINUTE PROMPT MODALS
// //           ========================================= */}
      
// //       {/* 1. The Prompt asking "Do you want to update?" */}
// //       <AnimatePresence>
// //         {showUpdatePrompt && (
// //           <motion.div 
// //             className="modal-overlay active"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //           >
// //             <motion.div 
// //               className="modal-card glass-card text-center"
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //             >
// //               <div className="modal-icon bg-gold-glow">
// //                 <i className="fa-solid fa-users"></i>
// //               </div>
// //               <h3 style={{ fontSize: '1.5rem', marginBottom: '10px', color: '#fff' }}>Update Attendance?</h3>
// //               <p style={{ color: '#94A3B8', marginBottom: '24px' }}>
// //                 It's been a while! Are more people watching with you now? Would you like to update your participant count?
// //               </p>
// //               <div className="modal-btn-row" style={{ justifyContent: 'center' }}>
// //                 <button className="btn btn-outline" onClick={() => setShowUpdatePrompt(false)}>
// //                   Not Now
// //                 </button>
// //                 <button 
// //                   className="btn btn-primary"
// //                   onClick={() => {
// //                     setShowUpdatePrompt(false);
// //                     setIsUpdatingParticipation(true);
// //                   }}
// //                 >
// //                   Yes, Update
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* 2. The Form Modal if they click "Yes, Update" */}
// //       <AnimatePresence>
// //         {isUpdatingParticipation && (
// //           <motion.div 
// //             className="modal-overlay active"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //           >
// //             <motion.div 
// //               className="modal-card glass-card"
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //             >
// //               <button className="modal-close" onClick={() => setIsUpdatingParticipation(false)}>
// //                 <CloseIcon />
// //               </button>
// //               <div className="modal-header">
// //                 <h3>🎯 Update Participation</h3>
// //                 <p>Add your new current total of participants</p>
// //               </div>
// //               <form onSubmit={(e) => handleFormSubmit(e, true)}>
// //                 <div className="form-group">
// //                   <label>Total Number of Participants</label>
// //                   <input
// //                     type="number"
// //                     value={numParticipants}
// //                     onChange={(e) => setNumParticipants(e.target.value)}
// //                     placeholder="Enter new total number"
// //                     min="1"
// //                     required
// //                   />
// //                 </div>
// //                 <button type="submit" disabled={loadingForm} className="btn btn-primary btn-full margin-top-sm">
// //                   {loadingForm ? 'Updating...' : 'Update Records →'}
// //                 </button>
// //               </form>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Sidebar */}
// //       <AnimatePresence>
// //         {isSidebarOpen && (
// //           <motion.div 
// //             className="sidebar-overlay active"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsSidebarOpen(false)}
// //           >
// //             <motion.div 
// //               className="sidebar"
// //               style={{ background: '#0B0813', borderRight: '1px solid rgba(255,255,255,0.1)' }}
// //               initial={{ x: -300 }}
// //               animate={{ x: 0 }}
// //               exit={{ x: -300 }}
// //               transition={{ type: 'spring', damping: 20 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="sidebar-header">
// //                 <div className="sidebar-user">
// //                   <img 
// //                     src={currentUser?.picturePath || defaultProfileImg} 
// //                     alt="Profile"
// //                     className="sidebar-avatar"
// //                   />
// //                   <div className="sidebar-user-info">
// //                     <span className="sidebar-name" style={{ color: '#fff' }}>{currentUser?.firstName} {currentUser?.lastName}</span>
// //                     <span className="sidebar-role" style={{ color: '#94A3B8' }}>{currentUser?.deptName}</span>
// //                   </div>
// //                 </div>
// //               </div>

// //               <nav className="sidebar-nav">
// //                 <a 
// //                   href="/" 
// //                   className="sidebar-link active"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">🏠</span>
// //                   Dashboard
// //                 </a>
                
// //                 <a 
// //                   href="/lndkingdom" 
// //                   className="sidebar-link"
// //                   onClick={(e) => {
// //                     e.preventDefault();
// //                     setIsSidebarOpen(false);
// //                     navigate('/lndkingdom');
// //                   }}
// //                 >
// //                   <span className="sidebar-icon">👑</span>
// //                   Life in the Kingdom
// //                 </a>
// //               </nav>

// //               <div className="sidebar-footer">
// //                 <button className="sidebar-logout" onClick={handleLogout}>
// //                   🚪 Logout
// //                 </button>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* Main Content Area */}
// //       <main style={{ paddingTop: '100px', zIndex: 1, position: 'relative' }}>
        
// //         {/* Welcome Banner */}
// //         <div className="max-width">
// //           <div className="welcome-banner glass-card" style={{ padding: '24px 32px', margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //             <div>
// //               <h2 style={{ fontSize: '1.6rem', marginBottom: '4px' }}>Welcome, <span className="text-gradient-gold">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h2>
// //               <p style={{ color: '#94A3B8', fontSize: '0.9rem' }}>📍 Loveworld Staff Development Centre</p>
// //             </div>
// //             <div className="badge-pill gold-pill" style={{ marginBottom: 0 }}>
// //                Live Dashboard
// //             </div>
// //           </div>
// //         </div>

// //         {/* Slider Banner */}
// //         <div className="max-width">
// //           <div className="slider-container glass-card" style={{ overflow: 'hidden', padding: 0, margin: '0 0 40px 0', border: '1px solid rgba(255,255,255,0.1)' }}>
// //             <div className="slider-wrapper">
// //               <AnimatePresence mode='wait'>
// //                 <motion.div 
// //                   key={currentSlide}
// //                   className="slide clickable-slide"
// //                   onClick={() => window.open(sliderImages[currentSlide].link, '_blank')}
// //                   initial={{ opacity: 0, scale: 0.95 }}
// //                   animate={{ opacity: 1, scale: 1 }}
// //                   exit={{ opacity: 0, scale: 0.95 }}
// //                   transition={{ duration: 0.5 }}
// //                 >
// //                   <img src={sliderImages[currentSlide].url} alt={sliderImages[currentSlide].title} className="slide-image" />
// //                 </motion.div>
// //               </AnimatePresence>
              
// //               <button className="slider-btn prev" onClick={prevSlide}>❮</button>
// //               <button className="slider-btn next" onClick={nextSlide}>❯</button>
              
// //               <div className="slider-dots">
// //                 {sliderImages.map((_, index) => (
// //                   <span key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} />
// //                 ))}
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* 60/40 Split Layout */}
// //         <div className="max-width main-content-layout">
// //           <div className="left-column">
// //             <div className="video-container glass-card" style={{ padding: '16px', border: '1px solid rgba(255,255,255,0.1)' }}>
// //               <VideoPlayer />
              
// //               <div className="social-actions" style={{ marginTop: '20px', padding: '10px 0', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
// //                 <div className="reaction" style={{ display: 'flex', gap: '20px' }}>
// //                   <div className="like" onClick={handleToggleLike} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.05)', padding: '8px 16px', borderRadius: '50px' }}>
// //                     <span role="img" aria-label="like">
// //                       {liked ? <FavoriteOutlinedIcon style={{ color: '#F59E0B' }} /> : <FavoriteBorderOutlinedIcon style={{ color: '#94A3B8' }} />}
// //                     </span>
// //                     <span className="count" style={{ color: '#fff', fontWeight: 'bold' }}>{totalLikes !== null ? totalLikes : 0}</span>
// //                   </div>

// //                   <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.05)', padding: '8px 16px', borderRadius: '50px' }}>
// //                     <span role="img" aria-label="comment">💬</span>
// //                     <span className="count" style={{ color: '#fff', fontWeight: 'bold' }}>{totalComments}</span>
// //                     <span className="label" style={{ color: '#94A3B8', fontSize: '0.85rem' }}>Comments</span>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="right-column">
// //             <div className="recommended-videos glass-card" style={{ padding: '24px' }}>
// //               <h4 style={{ fontSize: '1.2rem', marginBottom: '16px', color: '#fff' }}>🔥 Trending <span className="text-gradient-gold">Videos</span></h4>
// //               <div className="video-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
// //                 {trendingVideos.map(vid => (
// //                   <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')} style={{ display: 'flex', gap: '12px', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
// //                     <div className="thumb-container" style={{ width: '120px', height: '70px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
// //                       <img src={vid.thumb} alt={vid.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// //                     </div>
// //                     <div className="vid-details" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
// //                       <p style={{ fontSize: '0.9rem', color: '#fff', fontWeight: '600', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{vid.title}</p>
// //                       <span className="vid-action" style={{ fontSize: '0.75rem', color: '#9333EA', fontWeight: 'bold' }}>Get App to Watch →</span>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>

// //               <h4 className="mt-4" style={{ fontSize: '1.2rem', margin: '24px 0 16px', color: '#fff' }}>📚 Training <span className="text-gradient">Videos</span></h4>
// //               <div className="video-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
// //                 {trainingVideos.map(vid => (
// //                   <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')} style={{ display: 'flex', gap: '12px', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
// //                     <div className="thumb-container" style={{ width: '120px', height: '70px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
// //                       <img src={vid.thumb} alt={vid.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// //                     </div>
// //                     <div className="vid-details" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
// //                       <p style={{ fontSize: '0.9rem', color: '#fff', fontWeight: '600', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{vid.title}</p>
// //                       <span className="vid-action" style={{ fontSize: '0.75rem', color: '#9333EA', fontWeight: 'bold' }}>Get App to Watch →</span>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //       </main>

// //       {/* Comments Modal (Restructured for Mobile) */}
// //       <AnimatePresence>
// //         {isCommentsModalOpen && (
// //           <motion.div 
// //             className="modal-overlay active"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //             onClick={() => setIsCommentsModalOpen(false)}
// //           >
// //             <motion.div 
// //               className="modal-card glass-card"
// //               style={{ maxWidth: '600px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', padding: '0' }}
// //               initial={{ y: 50, opacity: 0 }}
// //               animate={{ y: 0, opacity: 1 }}
// //               exit={{ y: 50, opacity: 0 }}
// //               transition={{ type: 'spring', damping: 25 }}
// //               onClick={(e) => e.stopPropagation()}
// //             >
// //               <div className="modal-header" style={{ padding: '24px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0 }}>
// //                 <h3 style={{ margin: 0, fontSize: '1.4rem' }}>💬 Comments</h3>
// //                 <button style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '1.5rem', cursor: 'pointer' }} onClick={() => setIsCommentsModalOpen(false)}>
// //                   <CloseIcon />
// //                 </button>
// //               </div>

// //               <div style={{ padding: '24px', flex: 1, overflowY: 'auto' }}>
                
// //                 {/* Mobile Optimized Input */}
// //                 <div style={{ background: 'rgba(0,0,0,0.3)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)', marginBottom: '24px' }}>
// //                   <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
// //                     <img src={currentUser?.picturePath || defaultProfileImg} alt="Profile" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
// //                     <input
// //                       type="text"
// //                       placeholder="Write a comment..."
// //                       value={newComment}
// //                       onChange={(e) => setNewComment(e.target.value)}
// //                       style={{ flex: 1, background: 'transparent', border: 'none', color: '#fff', outline: 'none', fontSize: '1rem' }}
// //                     />
// //                   </div>
// //                   <button onClick={handleCreateComment} disabled={loading} className="btn btn-primary btn-full">
// //                     {loading ? 'Sending...' : 'Post Comment'}
// //                   </button>
// //                 </div>

// //                 <div className="comments-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
// //                   {comments.length === 0 ? (
// //                     <div className="text-center" style={{ padding: '40px 0', color: '#94A3B8' }}>
// //                       <span style={{ fontSize: '3rem', display: 'block', marginBottom: '10px' }}>💭</span>
// //                       <p>No comments yet. Be the first to comment!</p>
// //                     </div>
// //                   ) : (
// //                     comments.map((comment) => (
// //                       <div className="comment" key={comment._id} style={{ display: 'flex', gap: '16px', background: 'rgba(255,255,255,0.02)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
// //                         <img src={comment.picture?.uri || defaultProfileImg} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} />
// //                         <div>
// //                           <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '6px' }}>
// //                             <span style={{ fontWeight: 'bold', color: '#fff' }}>{comment.name}</span>
// //                             {/* Blue Department Label */}
// //                             <span style={{ background: 'rgba(37, 99, 235, 0.15)', color: '#60A5FA', padding: '4px 10px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold' }}>
// //                               {comment.department}
// //                             </span>
// //                           </div>
// //                           <p style={{ color: '#E2E8F0', marginBottom: '6px', fontSize: '0.95rem', lineHeight: '1.5' }}>{comment.text}</p>
// //                           <span style={{ fontSize: '0.75rem', color: '#64748B' }}>
// //                             {new Date(comment.createdAt).toLocaleString()}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     ))
// //                   )}
// //                 </div>
// //               </div>
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </div>
// //   );
// // };

// // export default Home;
// //drag



// import React, { useState, useEffect, useContext } from 'react';
// import './Home.css';
// import { AuthContext } from '../../context/authContext';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
// import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
// import VideoPlayer from './Videoplayer';
// import { motion, AnimatePresence } from 'framer-motion';
// import CloseIcon from '@mui/icons-material/Close';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

// const Home = () => {
//   const navigate = useNavigate();
//   const { currentUser, logout } = useContext(AuthContext);
  
//   // Layout & UI State
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [hasNotifications, setHasNotifications] = useState(true);
//   const [showNotificationToast, setShowNotificationToast] = useState(false);

//   const [isDarkTheme, setIsDarkTheme] = useState(true);

//   // Initial Form State
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [numParticipants, setNumParticipants] = useState('');
//   const [loadingForm, setLoadingForm] = useState(false);

//   // 45-Minute Periodic Prompt State
//   const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
//   const [isUpdatingParticipation, setIsUpdatingParticipation] = useState(false);

//   // Comments & Social State
//   const [newComment, setNewComment] = useState('');
//   const [comments, setComments] = useState([]);
//   const [totalLikes, setTotalLikes] = useState(null);
//   const [totalComments, setTotalComments] = useState(0);
//   const [liked, setLiked] = useState(false);
//   const [loading, setLoading] = useState(false);
  
//   const [currentSlide, setCurrentSlide] = useState(0);
  
//   const API_BASE_URL = 'https://api.stdl.site';
//   const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
//   const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

//   const sliderImages = [
//     {
//       url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/cVlCcXB0MUwwdlVuYjdVVXQrUFp0QT09/LWK.png',
//       title: 'Global Staff Training',
//       subtitle: 'The Last Lap of Completing Program',
//       // link: 'https://notc.rhapsodycrusades.org/blue-elite/register' 
//       link: '/lndkingdom' 
//     },
//     {
//       url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/cVlCcXB0MUwwdlVuYjdVVXQrUFp0QT09/LWK.png',
//       title: 'Staff Development Centre',
//       subtitle: 'Empowering Leaders Worldwide',
//      link: '/lndkingdom'     },
//     {
//       url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/cVlCcXB0MUwwdlVuYjdVVXQrUFp0QT09/LWK.png',
//       title: 'Staff Development Centre',
//       subtitle: 'Empowering Leaders Worldwide',
//       link: '/lndkingdom' 
//     },

//   ];
//   const trendingVideos = [
//     { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
//     { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
//   ];

//   const trainingVideos = [
//     { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
//     { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
//   ];

//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 40);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const promptInterval = setInterval(() => {
//       setShowUpdatePrompt(true);
//     }, 2700000); 
//     return () => clearInterval(promptInterval);
//   }, []);

//   useEffect(() => {
//     if (currentUser?.portalID) {
//       const hasSubmitted = localStorage.getItem(`participation_submitted_${currentUser.portalID}`);
//       if (hasSubmitted === 'true') {
//         setFormSubmitted(true);
//       }
//     }
//   }, [currentUser]);

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   const toggleTheme = () => {
//     setIsDarkTheme(!isDarkTheme);
//     document.body.classList.toggle('dark-theme');
//   };

//   const handleNotificationClick = () => {
//     setHasNotifications(false);
//     setShowNotificationToast(true);
//     setTimeout(() => setShowNotificationToast(false), 3000);
//   };

//   const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
//   const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

//   useEffect(() => {
//     document.body.classList.add('dark-theme');
//     const timer = setInterval(nextSlide, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   const handleFormSubmit = async (e, isUpdate = false) => {
//     e.preventDefault();
//     if (!numParticipants.trim()) return alert('Please fill in all fields');
//     if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

//     try {
//       setLoadingForm(true);
//       await axios.post(`${API_BASE_URL}/participation`, {
//         userId: currentUser?.portalID,
//         name: `${currentUser?.title} ${currentUser?.firstName} ${currentUser?.lastName}`,
//         department: currentUser?.deptName,
//         participants: numParticipants,
//       });
      
//       if (currentUser?.portalID) {
//         localStorage.setItem(`participation_submitted_${currentUser.portalID}`, 'true');
//       }
      
//       if (isUpdate) {
//         setIsUpdatingParticipation(false);
//         setNumParticipants(''); 
//       } else {
//         setFormSubmitted(true);
//       }
//     } catch (error) {
//       console.error("Error submitting participation form:", error);
//       alert("There was an issue submitting the form. Try again.");
//     } finally {
//       setLoadingForm(false);
//     }
//   };

//   const fetchComments = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/gentComments`);
//       setComments(res.data.comments);
//     } catch (error) {
//       console.error("Error fetching comments:", error);
//     }
//   };

//   const fetchTotalComments = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
//       setTotalComments(res.data.totalComments);
//     } catch (error) {
//       console.error("Error fetching total comments:", error);
//     }
//   };

//   const fetchTotalLikes = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
//       setTotalLikes(res.data.totalLikes);
//     } catch (error) {
//       console.error("Error fetching total likes:", error);
//     }
//   };

//   const handleToggleLike = async () => {
//     try {
//       const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId: currentUser?.portalID });
//       setLiked(res.data.liked);
//       fetchTotalLikes();
//     } catch (error) {
//       console.error("Error toggling like:", error);
//     }
//   };

//   const handleCreateComment = async () => {
//     if (newComment.trim() === "") return;
//     setLoading(true);
//     try {
//       const res = await axios.post(`${API_BASE_URL}/gentComment`, {
//         userId: currentUser?.portalID,
//         text: newComment,
//         name: currentUser?.title + " " + currentUser?.firstName + " " + currentUser?.lastName,
//         picture: { uri: currentUser?.picturePath },
//         department: currentUser.deptName,
//       });
//       setComments([res.data.comment, ...comments]);
//       setNewComment("");
//       setTotalComments(totalComments + 1);
//     } catch (error) {
//       console.error("Error creating comment:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (formSubmitted) {
//       fetchComments();
//       fetchTotalLikes();
//       fetchTotalComments();

//       const intervalId = setInterval(() => {
//         fetchComments();
//         fetchTotalLikes();
//         fetchTotalComments();
//       }, 10000);
//       return () => clearInterval(intervalId);
//     }
//   }, [formSubmitted, currentUser?.portalID]);

//   if (!formSubmitted) {
//     return (
//       <div className="app-container">
//         <div className="bg-glow glow-1"></div>
//         <div className="bg-glow glow-3"></div>
        
//         <div className="participation-form-container glass-card" style={{ maxWidth: '500px', width: '90%', margin: '100px auto', zIndex: 10, position: 'relative' }}>
//           <div className="form-header">
//             <h2 className="section-title" style={{ fontSize: '2rem' }}>🎯 Registration</h2>
//             <p className="section-subtitle">Please confirm your attendance</p>
//           </div>
//           <form onSubmit={(e) => handleFormSubmit(e, false)} className="participation-form">
//             <div className="form-group" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
//               <label style={{ color: '#F8FAFC', marginBottom: '8px', display: 'block' }}>Number of Participants</label>
//               <input
//                 type="number"
//                 value={numParticipants}
//                 onChange={(e) => setNumParticipants(e.target.value)}
//                 placeholder="Enter number of participants"
//                 min="1"
//                 required
//                 style={{ width: '100%', padding: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px' }}
//               />
//             </div>
//             <button type="submit" disabled={loadingForm} className="btn btn-primary btn-full" style={{ padding: '16px' }}>
//               {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
//             </button>
//           </form>
//         </div>
//       </div>
//     );
//   }
//   // Handle banner clicks (Internal vs External)
//   const handleBannerClick = (link) => {
//     if (link.startsWith('http')) {
//       window.open(link, '_blank'); // Opens external links in a new tab
//     } else {
//       navigate(link); // Uses React Router for internal pages
//     }
//   };
// //slide clickable-slide
//   return (
//     <div className="app-container">
      
//       {/* Background Ambient Glows */}
//       <div className="bg-glow glow-1"></div>
//       <div className="bg-glow glow-2"></div>
//       <div className="bg-glow glow-3"></div>

//       {/* Scrolling Ticker */}
//       <div className="scrolling-ticker">
//         <div className="ticker-text">
//           🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression! Explore the latest training content now.
//         </div>
//       </div>

//       {/* Sleek Navigation Bar */}
//       <header className={`navbar-container ${isScrolled ? 'scrolled' : ''}`} style={{ top: '38px' }}>
//         <nav className="navbar max-width">
//           <div className="logo-group">
//             <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
//               <span className="hamburger-icon">☰</span>
//             </button>
//             <div className="logo-badge">STDL</div>
//             <div className="brand-text">
//               <span className="brand-title">Dashboard</span>
//               <span className="brand-sub">FOR STAFF</span>
//             </div>
//           </div>

//           <div className="nav-actions">
//             <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
//               {hasNotifications ? (
//                 <>
//                   <NotificationsIcon className="notification-icon" />
//                   <span className="notification-badge">3</span>
//                 </>
//               ) : (
//                 <NotificationsNoneIcon className="notification-icon" />
//               )}
//             </button>
//             <img 
//               src={currentUser?.picturePath || defaultProfileImg} 
//               alt="Profile" 
//               className="topbar-profile-pic"
//               onClick={() => setIsSidebarOpen(true)}
//             />
//           </div>
//         </nav>
//       </header>

//       {/* Sleek Notification Toast */}
//       <AnimatePresence>
//         {showNotificationToast && (
//           <motion.div 
//             className="notification-toast glass-card"
//             initial={{ opacity: 0, y: -20, scale: 0.9 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: -20, scale: 0.9 }}
//             transition={{ type: "spring", stiffness: 300, damping: 25 }}
//           >
//             <div className="toast-icon-wrapper bg-purple-glow">
//               <NotificationsNoneIcon className="toast-bell-icon" />
//             </div>
//             <div className="toast-text">
//               <h4>No Notifications</h4>
//               <p>You're all caught up!</p>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
      
//       {/* 1. The Prompt asking "Do you want to update?" */}
//       <AnimatePresence>
//         {showUpdatePrompt && (
//           <motion.div 
//             className="modal-overlay active"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             <motion.div 
//               className="modal-card glass-card text-center"
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               exit={{ y: 50, opacity: 0 }}
//             >
//               <div className="modal-icon bg-gold-glow">
//                 <i className="fa-solid fa-users"></i>
//               </div>
//               <h3 style={{ fontSize: '1.5rem', marginBottom: '10px', color: '#fff' }}>Update Attendance?</h3>
//               <p style={{ color: '#94A3B8', marginBottom: '24px' }}>
//                 It's been a while! Are more people watching with you now? Would you like to update your participant count?
//               </p>
//               <div className="modal-btn-row" style={{ justifyContent: 'center' }}>
//                 <button className="btn btn-outline" onClick={() => setShowUpdatePrompt(false)}>
//                   Not Now
//                 </button>
//                 <button 
//                   className="btn btn-primary"
//                   onClick={() => {
//                     setShowUpdatePrompt(false);
//                     setIsUpdatingParticipation(true);
//                   }}
//                 >
//                   Yes, Update
//                 </button>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* 2. The Form Modal if they click "Yes, Update" */}
//       <AnimatePresence>
//         {isUpdatingParticipation && (
//           <motion.div 
//             className="modal-overlay active"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             <motion.div 
//               className="modal-card glass-card participation-form-container"
//               style={{ width: '90%', maxWidth: '500px', margin: 'auto', padding: '2rem' }}
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               exit={{ y: 50, opacity: 0 }}
//             >
//               <button className="modal-close" onClick={() => setIsUpdatingParticipation(false)}>
//                 <CloseIcon />
//               </button>
//               <div className="modal-header">
//                 <h3>🎯 Update Participation</h3>
//                 <p>Add your new current total of participants</p>
//               </div>
//               <form onSubmit={(e) => handleFormSubmit(e, true)}>
//                 <div className="form-group" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
//                   <label style={{ color: '#F8FAFC', marginBottom: '8px', display: 'block' }}>Total Number of Participants</label>
//                   <input
//                     type="number"
//                     value={numParticipants}
//                     onChange={(e) => setNumParticipants(e.target.value)}
//                     placeholder="Enter new total number"
//                     min="1"
//                     required
//                     style={{ width: '100%', padding: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px' }}
//                   />
//                 </div>
//                 <button type="submit" disabled={loadingForm} className="btn btn-primary btn-full margin-top-sm">
//                   {loadingForm ? 'Updating...' : 'Update Records →'}
//                 </button>
//               </form>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Sidebar */}
//       <AnimatePresence>
//         {isSidebarOpen && (
//           <motion.div 
//             className="sidebar-overlay active"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={() => setIsSidebarOpen(false)}
//           >
//             <motion.div 
//               className="sidebar"
//               style={{ background: '#0B0813', borderRight: '1px solid rgba(255,255,255,0.1)' }}
//               initial={{ x: -300 }}
//               animate={{ x: 0 }}
//               exit={{ x: -300 }}
//               transition={{ type: 'spring', damping: 20 }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="sidebar-header">
//                 <div className="sidebar-user">
//                   <img 
//                     src={currentUser?.picturePath || defaultProfileImg} 
//                     alt="Profile"
//                     className="sidebar-avatar"
//                   />
//                   <div className="sidebar-user-info">
//                     <span className="sidebar-name" style={{ color: '#fff' }}>{currentUser?.firstName} {currentUser?.lastName}</span>
//                     <span className="sidebar-role" style={{ color: '#94A3B8' }}>{currentUser?.deptName}</span>
//                   </div>
//                 </div>
//               </div>

//               <nav className="sidebar-nav">
//                 <a 
//                   href="/" 
//                   className="sidebar-link active"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setIsSidebarOpen(false);
//                     navigate('/');
//                   }}
//                 >
//                   <span className="sidebar-icon">🏠</span>
//                   Dashboard
//                 </a>
                
//                 <a 
//                   href="/lndkingdom" 
//                   className="sidebar-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setIsSidebarOpen(false);
//                     navigate('/lndkingdom');
//                   }}
//                 >
//                   <span className="sidebar-icon">👑</span>
//                   Life in the Kingdom
//                 </a>
//               </nav>

//               <div className="sidebar-footer">
//                 <button className="sidebar-logout" onClick={handleLogout}>
//                   🚪 Logout
//                 </button>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Main Content Area */}
//       <main style={{ paddingTop: '110px', zIndex: 1, position: 'relative' }}>
        
//         {/* Welcome Banner */}
//         <div className="max-width">
//           <div className="welcome-banner glass-card" style={{ padding: '24px 32px', margin: '10px 0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <div>
//               <h2 style={{ fontSize: '1.2rem', marginBottom: '4px' }}>Welcome, <span className="text-gradient-gold">{currentUser?.title} {currentUser?.firstName} {currentUser?.lastName}!</span></h2>
//               <p style={{ color: '#94A3B8', fontSize: '0.9rem' }}>📍 Loveworld Staff Development Centre</p>
//             </div>
//             <div className="badge-pill gold-pill desktop-only" style={{ marginBottom: 0 }}>
//                Live Dashboard
//             </div>
//           </div>
//         </div>

//         {/* Slider Banner */}
//         <div className="max-width">
//           <div className="slider-container glass-card" style={{ overflow: 'hidden', padding: 0, margin: '0 0 30px 0', border: '1px solid rgba(255,255,255,0.1)' }}>
//             <div className="slider-wrapper">
//          <AnimatePresence mode='wait'>
//                 <motion.div 
//                   key={currentSlide}
//                   className="slide clickable-slide"
//                   onClick={() => handleBannerClick(sliderImages[currentSlide].link)}
//                   initial={{ opacity: 0, scale: 0.95 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   exit={{ opacity: 0, scale: 0.95 }}
//                   transition={{ duration: 0.5 }}
//                 >
//                   <img src={sliderImages[currentSlide].url} alt={sliderImages[currentSlide].title} className="slide-image" />
//                 </motion.div>
//               </AnimatePresence>
              
//               <button className="slider-btn prev" onClick={prevSlide}>❮</button>
//               <button className="slider-btn next" onClick={nextSlide}>❯</button>
              
//               <div className="slider-dots">
//                 {sliderImages.map((_, index) => (
//                   <span key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} />
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* 60/40 Split Layout */}
//         <div className="max-width main-content-layout">
//           <div className="left-column">
//             {/* <div className="video-container glass-card" style={{ padding: '16px', border: '1px solid rgba(255,255,255,0.1)' }}> */}
// <div className="video-container glass-card">
//               <VideoPlayer />
              
//               {/* <div className="social-actions" style={{ marginTop: '20px', padding: '10px 0', borderTop: '1px solid rgba(255,255,255,0.05)' }}> */}
//                <div className="social-actions" style={{ marginTop: '20px', padding: '10px 0', borderTop: '1px solid rgba(255,255,255,0.05)' }}>   
                
//                 <div className="reaction" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
//                   <div className="like" onClick={handleToggleLike} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.05)', padding: '8px 16px', borderRadius: '50px' }}>
//                     <span role="img" aria-label="like">
//                       {liked ? <FavoriteOutlinedIcon style={{ color: '#F59E0B' }} /> : <FavoriteBorderOutlinedIcon style={{ color: '#94A3B8' }} />}
//                     </span>
//                     <span className="count" style={{ color: '#fff', fontWeight: 'bold' }}>{totalLikes !== null ? totalLikes : 0}</span>
//                   </div>

//                   <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.05)', padding: '8px 16px', borderRadius: '50px' }}>
//                     <span role="img" aria-label="comment">💬</span>
//                     <span className="count" style={{ color: '#fff', fontWeight: 'bold' }}>{totalComments}</span>
//                     <span className="label" style={{ color: '#94A3B8', fontSize: '0.85rem' }}>Comments</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="right-column">
//             <div className="recommended-videos glass-card" style={{ padding: '24px' }}>
//               <h4 style={{ fontSize: '1.2rem', marginBottom: '16px', color: '#fff' }}>🔥 Trending <span className="text-gradient-gold">Videos</span></h4>
//               <div className="video-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                 {trendingVideos.map(vid => (
//                   <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')} style={{ display: 'flex', gap: '12px', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
//                     <div className="thumb-container" style={{ width: '100px', height: '65px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
//                       <img src={vid.thumb} alt={vid.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                     </div>
//                     <div className="vid-details" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//                       <p style={{ fontSize: '0.9rem', color: '#fff', fontWeight: '600', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{vid.title}</p>
//                       <span className="vid-action" style={{ fontSize: '0.75rem', color: '#9333EA', fontWeight: 'bold' }}>Get App to Watch →</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <h4 className="mt-4" style={{ fontSize: '1.2rem', margin: '24px 0 16px', color: '#fff' }}>📚 Training <span className="text-gradient">Videos</span></h4>
//               <div className="video-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                 {trainingVideos.map(vid => (
//                   <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')} style={{ display: 'flex', gap: '12px', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
//                     <div className="thumb-container" style={{ width: '100px', height: '65px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
//                       <img src={vid.thumb} alt={vid.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                     </div>
//                     <div className="vid-details" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//                       <p style={{ fontSize: '0.9rem', color: '#fff', fontWeight: '600', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{vid.title}</p>
//                       <span className="vid-action" style={{ fontSize: '0.75rem', color: '#9333EA', fontWeight: 'bold' }}>Get App to Watch →</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>

//       </main>

//       {/* Comments Modal (Restructured for Mobile) */}
//       <AnimatePresence>
//         {isCommentsModalOpen && (
//           <motion.div 
//             className="modal-overlay active"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={() => setIsCommentsModalOpen(false)}
//           >
//             <motion.div 
//               className="modal-card glass-card"
//               style={{ width: '95%', maxWidth: '600px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', padding: '0', margin: 'auto' }}
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               exit={{ y: 50, opacity: 0 }}
//               transition={{ type: 'spring', damping: 25 }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="modal-header" style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0 }}>
//                 <h3 style={{ margin: 0, fontSize: '1.25rem', color: '#fff' }}>💬 Comments</h3>
//                 <button style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '1.5rem', cursor: 'pointer' }} onClick={() => setIsCommentsModalOpen(false)}>
//                   <CloseIcon />
//                 </button>
//               </div>

//               <div style={{ padding: '20px 24px', flex: 1, overflowY: 'auto' }}>
                
//                 {/* Mobile Optimized Input */}
//                 <div style={{ background: 'rgba(0,0,0,0.3)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)', marginBottom: '24px' }}>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
//                     <img src={currentUser?.picturePath || defaultProfileImg} alt="Profile" style={{ width: '36px', height: '36px', borderRadius: '50%' }} />
//                     <input
//                       type="text"
//                       placeholder="Write a comment..."
//                       value={newComment}
//                       onChange={(e) => setNewComment(e.target.value)}
//                       style={{ flex: 1, background: 'transparent', border: 'none', color: '#fff', outline: 'none', fontSize: '0.95rem' }}
//                     />
//                   </div>
//                   <button onClick={handleCreateComment} disabled={loading} className="btn btn-primary btn-full">
//                     {loading ? 'Sending...' : 'Post Comment'}
//                   </button>
//                 </div>

//                 <div className="comments-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                   {comments.length === 0 ? (
//                     <div className="text-center" style={{ padding: '40px 0', color: '#94A3B8' }}>
//                       <span style={{ fontSize: '3rem', display: 'block', marginBottom: '10px' }}>💭</span>
//                       <p>No comments yet. Be the first to comment!</p>
//                     </div>
//                   ) : (
//                     comments.map((comment) => (
//                       <div className="comment" key={comment._id} style={{ display: 'flex', gap: '12px', background: 'rgba(255,255,255,0.02)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
//                         <img src={comment.picture?.uri || defaultProfileImg} alt="" style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
//                         <div style={{ width: '100%', overflow: 'hidden' }}>
//                           <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
//                             <span style={{ fontWeight: 'bold', color: '#fff', fontSize: '0.9rem' }}>{comment.name}</span>
//                             {/* Blue Department Label */}
//                             <span style={{ background: 'rgba(37, 99, 235, 0.15)', color: '#60A5FA', padding: '2px 8px', borderRadius: '20px', fontSize: '0.7rem', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
//                               {comment.department}
//                             </span>
//                           </div>
//                           <p style={{ color: '#E2E8F0', marginBottom: '6px', fontSize: '0.9rem', lineHeight: '1.4', wordBreak: 'break-word' }}>{comment.text}</p>
//                           <span style={{ fontSize: '0.7rem', color: '#64748B' }}>
//                             {new Date(comment.createdAt).toLocaleString()}
//                           </span>
//                         </div>
//                       </div>
//                     ))
//                   )}
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default Home;




import React, { useState, useEffect, useContext } from 'react';
import './Home.css';
import { AuthContext } from '../../context/authContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import VideoPlayer from './Videoplayer';
import { motion, AnimatePresence } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

const Home = () => {
  const navigate = useNavigate();
  const { currentUser, logout } = useContext(AuthContext);
  
  // Layout & UI State
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [hasNotifications, setHasNotifications] = useState(true);
  const [showNotificationToast, setShowNotificationToast] = useState(false);

  const [isDarkTheme, setIsDarkTheme] = useState(true);

  // Initial Form State
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [numParticipants, setNumParticipants] = useState('');
  const [loadingForm, setLoadingForm] = useState(false);

  // 45-Minute Periodic Prompt State - Only for non-admin users
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const [isUpdatingParticipation, setIsUpdatingParticipation] = useState(false);

  // Comments & Social State
  const [newComment, setNewComment] = useState('');
  const [comments, setComments] = useState([]);
  const [totalLikes, setTotalLikes] = useState(null);
  const [totalComments, setTotalComments] = useState(0);
  const [liked, setLiked] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const API_BASE_URL = 'https://api.stdl.site';
  const APP_DOWNLOAD_LINK = "https://web.lwappstore.com/share/lW-sA-D70-ZI579";
  const defaultProfileImg = "https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png";

  // Check if user is admin
  const isAdmin = currentUser?.isAdmin === true;

  const sliderImages = [
    {
      url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/T2lQWnduS3UyTm5iTDhiRFlWV1RPZz09/lates.jpg',
      title: 'Global Staff Training',
      subtitle: 'The Last Lap of Completing Program',
      link: 'https://web.lwappstore.com/share/appId-7d63342107dd8e64b326708c075d9824' 
    },
    {
      url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/T2lQWnduS3UyTm5iTDhiRFlWV1RPZz09/lates.jpg',
      title: 'Staff Development Centre',
      subtitle: 'Empowering Leaders Worldwide',
      link: 'https://web.lwappstore.com/share/appId-7d63342107dd8e64b326708c075d9824' 
    },
    {
      url: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/T2lQWnduS3UyTm5iTDhiRFlWV1RPZz09/lates.jpg',
      title: 'Staff Development Centre',
      subtitle: 'Empowering Leaders Worldwide',
      link: 'https://web.lwappstore.com/share/appId-7d63342107dd8e64b326708c075d9824' 
    },
  ];

  const trendingVideos = [
    { id: 1, title: 'NIGHT OF A THOUSAND CRUSADES | GLOBAL STAFF EDITION', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/bDVqZUxpQlFCMDR6dDd3eWhpQlNrQT09/1001340449.jpg', duration: '5:20' },
    { id: 2, title: 'BETA Night of A Thousand Crusades Edition | Pastor Bisi Osademe', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/dWpQeVBWNmMzQlAzbSswU0RDOS9xQT09/Pastor_bisi.jpg', duration: '12:05' }
  ];

  const trainingVideos = [
    { id: 3, title: 'Prospering in Health Episode 6 | Hydration & Its Powerful Role', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/MTRXMmlnVGF6bElLRGMrTDdXbFNJQT09/episode_6_thumnail.jpg', duration: '47:45' },
    { id: 4, title: 'Prospering in Health Episode 4 | Maintaining Healthy Skin Part 2', thumb: 'https://cdn1.kingschat.online/uploads/media/5a47c4b1e694aa198f6ceecb/R3BjZkkxb3dLRk1oQldiVGdNN1NqUT09/TTTTTTTT.jpg', duration: '45:30' }
  ];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Only set up periodic prompt for non-admin users
  useEffect(() => {
    if (!isAdmin) {
      const promptInterval = setInterval(() => {
        setShowUpdatePrompt(true);
      }, 2700000); // 45 minutes
      return () => clearInterval(promptInterval);
    }
  }, [isAdmin]);

  // Check if form is submitted - skip for admin
  useEffect(() => {
    if (isAdmin) {
      // Admin doesn't need to submit participation
      setFormSubmitted(true);
    } else if (currentUser?.portalID) {
      const hasSubmitted = localStorage.getItem(`participation_submitted_${currentUser.portalID}`);
      if (hasSubmitted === 'true') {
        setFormSubmitted(true);
      }
    }
  }, [currentUser, isAdmin]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
    document.body.classList.toggle('dark-theme');
  };

  const handleNotificationClick = () => {
    setHasNotifications(false);
    setShowNotificationToast(true);
    setTimeout(() => setShowNotificationToast(false), 3000);
  };

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

  useEffect(() => {
    document.body.classList.add('dark-theme');
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleFormSubmit = async (e, isUpdate = false) => {
    e.preventDefault();
    
    // Prevent admin from submitting participation
    if (isAdmin) {
      alert('Admin does not need to submit participation.');
      return;
    }
    
    if (!numParticipants.trim()) return alert('Please fill in all fields');
    if (Number(numParticipants) < 1) return alert('Number of participants must be at least 1');

    try {
      setLoadingForm(true);
      await axios.post(`${API_BASE_URL}/participation`, {
        userId: currentUser?.portalID,
        name: `${currentUser?.title || ''} ${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim(),
        department: currentUser?.deptName || 'Unknown',
        participants: numParticipants,
      });
      
      if (currentUser?.portalID) {
        localStorage.setItem(`participation_submitted_${currentUser.portalID}`, 'true');
      }
      
      if (isUpdate) {
        setIsUpdatingParticipation(false);
        setNumParticipants(''); 
      } else {
        setFormSubmitted(true);
      }
    } catch (error) {
      console.error("Error submitting participation form:", error);
      alert("There was an issue submitting the form. Try again.");
    } finally {
      setLoadingForm(false);
    }
  };

  const fetchComments = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/gentComments`);
      setComments(res.data.comments);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const fetchTotalComments = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/gentComments/total`);
      setTotalComments(res.data.totalComments);
    } catch (error) {
      console.error("Error fetching total comments:", error);
    }
  };

  const fetchTotalLikes = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/gentlikes/total`);
      setTotalLikes(res.data.totalLikes);
    } catch (error) {
      console.error("Error fetching total likes:", error);
    }
  };

  const handleToggleLike = async () => {
    try {
      const userId = isAdmin ? 'ocosadmin' : currentUser?.portalID;
      const res = await axios.post(`${API_BASE_URL}/gentlikes`, { userId });
      setLiked(res.data.liked);
      fetchTotalLikes();
    } catch (error) {
      console.error("Error toggling like:", error);
    }
  };

  const handleCreateComment = async () => {
    if (newComment.trim() === "") return;
    setLoading(true);
    try {
      const userId = isAdmin ? 'ocosadmin' : currentUser?.portalID;
      const name = isAdmin ? 'OCOS Admin' : `${currentUser?.title || ''} ${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim();
      const department = isAdmin ? 'Administration' : currentUser?.deptName || 'Unknown';
      
      const res = await axios.post(`${API_BASE_URL}/gentComment`, {
        userId: userId,
        text: newComment,
        name: name,
        picture: { uri: currentUser?.picturePath || defaultProfileImg },
        department: department,
      });
      setComments([res.data.comment, ...comments]);
      setNewComment("");
      setTotalComments(totalComments + 1);
    } catch (error) {
      console.error("Error creating comment:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formSubmitted) {
      fetchComments();
      fetchTotalLikes();
      fetchTotalComments();

      const intervalId = setInterval(() => {
        fetchComments();
        fetchTotalLikes();
        fetchTotalComments();
      }, 10000);
      return () => clearInterval(intervalId);
    }
  }, [formSubmitted]);

  // Show participation form only for non-admin users who haven't submitted
  if (!formSubmitted && !isAdmin) {
    return (
      <div className="app-container">
        <div className="bg-glow glow-1"></div>
        <div className="bg-glow glow-3"></div>
        
        <div className="participation-form-container glass-card" style={{ maxWidth: '500px', width: '90%', margin: '100px auto', zIndex: 10, position: 'relative' }}>
          <div className="form-header">
            <h2 className="section-title" style={{ fontSize: '2rem' }}>🎯 Registration</h2>
            <p className="section-subtitle">Please confirm your attendance</p>
          </div>
          <form onSubmit={(e) => handleFormSubmit(e, false)} className="participation-form">
            <div className="form-group" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
              <label style={{ color: '#F8FAFC', marginBottom: '8px', display: 'block' }}>Number of Participants</label>
              <input
                type="number"
                value={numParticipants}
                onChange={(e) => setNumParticipants(e.target.value)}
                placeholder="Enter number of participants"
                min="1"
                required
                style={{ width: '100%', padding: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px' }}
              />
            </div>
            <button type="submit" disabled={loadingForm} className="btn btn-primary btn-full" style={{ padding: '16px' }}>
              {loadingForm ? 'Submitting...' : 'Submit & Continue →'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Handle banner clicks (Internal vs External)
  const handleBannerClick = (link) => {
    if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  };

  // Get display name for user
  const getDisplayName = () => {
    if (isAdmin) {
      return 'OCOS Admin';
    }
    return `${currentUser?.title || ''} ${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim() || 'User';
  };

  // Get display department
  const getDisplayDepartment = () => {
    if (isAdmin) {
      return 'Administrator';
    }
    return currentUser?.deptName || 'Staff';
  };

  return (
    <div className="app-container">
      
      {/* Background Ambient Glows */}
      <div className="bg-glow glow-1"></div>
      <div className="bg-glow glow-2"></div>
      <div className="bg-glow glow-3"></div>

      {/* Scrolling Ticker */}
      <div className="scrolling-ticker">
        <div className="ticker-text">
          🚀 Welcome to {new Date().toLocaleString('default', { month: 'long' })} — The Month of Progression! Explore the latest training content now.
        </div>
      </div>

      {/* Sleek Navigation Bar */}
      <header className={`navbar-container ${isScrolled ? 'scrolled' : ''}`} style={{ top: '38px' }}>
        <nav className="navbar max-width">
          <div className="logo-group">
            <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
              <span className="hamburger-icon">☰</span>
            </button>
            <div className="logo-badge">STDL</div>
            <div className="brand-text">
              <span className="brand-title">Dashboard</span>
              <span className="brand-sub">FOR STAFF</span>
            </div>
          </div>

          <div className="nav-actions">
            <button className="notification-btn" onClick={handleNotificationClick} title="Notifications">
              {hasNotifications ? (
                <>
                  <NotificationsIcon className="notification-icon" />
                  <span className="notification-badge">3</span>
                </>
              ) : (
                <NotificationsNoneIcon className="notification-icon" />
              )}
            </button>
            <img 
              src={currentUser?.picturePath || defaultProfileImg} 
              alt="Profile" 
              className="topbar-profile-pic"
              onClick={() => setIsSidebarOpen(true)}
            />
          </div>
        </nav>
      </header>

      {/* Sleek Notification Toast */}
      <AnimatePresence>
        {showNotificationToast && (
          <motion.div 
            className="notification-toast glass-card"
            initial={{ opacity: 0, y: -20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
          >
            <div className="toast-icon-wrapper bg-purple-glow">
              <NotificationsNoneIcon className="toast-bell-icon" />
            </div>
            <div className="toast-text">
              <h4>No Notifications</h4>
              <p>You're all caught up!</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      
      {/* 1. The Prompt asking "Do you want to update?" - Only for non-admin */}
      {!isAdmin && (
        <AnimatePresence>
          {showUpdatePrompt && (
            <motion.div 
              className="modal-overlay active"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <motion.div 
                className="modal-card glass-card text-center"
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
              >
                <div className="modal-icon bg-gold-glow">
                  <i className="fa-solid fa-users"></i>
                </div>
                <h3 style={{ fontSize: '1.5rem', marginBottom: '10px', color: '#fff' }}>Update Attendance?</h3>
                <p style={{ color: '#94A3B8', marginBottom: '24px' }}>
                  It's been a while! Are more people watching with you now? Would you like to update your participant count?
                </p>
                <div className="modal-btn-row" style={{ justifyContent: 'center' }}>
                  <button className="btn btn-outline" onClick={() => setShowUpdatePrompt(false)}>
                    Not Now
                  </button>
                  <button 
                    className="btn btn-primary"
                    onClick={() => {
                      setShowUpdatePrompt(false);
                      setIsUpdatingParticipation(true);
                    }}
                  >
                    Yes, Update
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      )}

      {/* 2. The Form Modal if they click "Yes, Update" - Only for non-admin */}
      {!isAdmin && (
        <AnimatePresence>
          {isUpdatingParticipation && (
            <motion.div 
              className="modal-overlay active"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <motion.div 
                className="modal-card glass-card participation-form-container"
                style={{ width: '90%', maxWidth: '500px', margin: 'auto', padding: '2rem' }}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
              >
                <button className="modal-close" onClick={() => setIsUpdatingParticipation(false)}>
                  <CloseIcon />
                </button>
                <div className="modal-header">
                  <h3>🎯 Update Participation</h3>
                  <p>Add your new current total of participants</p>
                </div>
                <form onSubmit={(e) => handleFormSubmit(e, true)}>
                  <div className="form-group" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
                    <label style={{ color: '#F8FAFC', marginBottom: '8px', display: 'block' }}>Total Number of Participants</label>
                    <input
                      type="number"
                      value={numParticipants}
                      onChange={(e) => setNumParticipants(e.target.value)}
                      placeholder="Enter new total number"
                      min="1"
                      required
                      style={{ width: '100%', padding: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px' }}
                    />
                  </div>
                  <button type="submit" disabled={loadingForm} className="btn btn-primary btn-full margin-top-sm">
                    {loadingForm ? 'Updating...' : 'Update Records →'}
                  </button>
                </form>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      )}

      {/* Sidebar */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div 
            className="sidebar-overlay active"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsSidebarOpen(false)}
          >
            <motion.div 
              className="sidebar"
              style={{ background: '#0B0813', borderRight: '1px solid rgba(255,255,255,0.1)' }}
              initial={{ x: -300 }}
              animate={{ x: 0 }}
              exit={{ x: -300 }}
              transition={{ type: 'spring', damping: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sidebar-header">
                <div className="sidebar-user">
                  <img 
                    src={currentUser?.picturePath || defaultProfileImg} 
                    alt="Profile"
                    className="sidebar-avatar"
                  />
                  <div className="sidebar-user-info">
                    <span className="sidebar-name" style={{ color: '#fff' }}>
                      {getDisplayName()}
                    </span>
                    <span className="sidebar-role" style={{ color: '#94A3B8' }}>
                      {getDisplayDepartment()}
                      {isAdmin && <span style={{ color: '#F59E0B', marginLeft: '8px' }}>👑</span>}
                    </span>
                  </div>
                </div>
              </div>

              <nav className="sidebar-nav">
                <a 
                  href="/" 
                  className="sidebar-link active"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSidebarOpen(false);
                    navigate('/');
                  }}
                >
                  <span className="sidebar-icon">🏠</span>
                  Dashboard
                </a>
                
                <a 
                  href="/lndkingdom" 
                  className="sidebar-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSidebarOpen(false);
                    navigate('/lndkingdom');
                  }}
                >
                  <span className="sidebar-icon">👑</span>
                  Life in the Kingdom
                </a>

                {isAdmin && (
                  <a 
                    href="#" 
                    className="sidebar-link"
                    style={{ background: 'rgba(245, 158, 11, 0.1)', borderLeft: '3px solid #F59E0B' }}
                    onClick={(e) => {
                      e.preventDefault();
                      setIsSidebarOpen(false);
                      // Add admin panel link if needed
                    }}
                  >
                    <span className="sidebar-icon">⚙️</span>
                    Admin Panel
                  </a>
                )}
              </nav>

              <div className="sidebar-footer">
                <button className="sidebar-logout" onClick={handleLogout}>
                  🚪 Logout
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Content Area */}
      <main style={{ paddingTop: '110px', zIndex: 1, position: 'relative' }}>
        
        {/* Welcome Banner */}
        <div className="max-width">
          <div className="welcome-banner glass-card" style={{ padding: '24px 32px', margin: '10px 0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: '1.2rem', marginBottom: '4px' }}>
                Welcome, <span className="text-gradient-gold">
                  {getDisplayName()}
                  {isAdmin && <span style={{ fontSize: '0.8rem', marginLeft: '10px', background: '#F59E0B', color: '#000', padding: '2px 12px', borderRadius: '20px' }}>Admin</span>}
                </span>!
              </h2>
              <p style={{ color: '#94A3B8', fontSize: '0.9rem' }}>
                📍 {isAdmin ? 'Administration Panel' : 'Loveworld Staff Development Centre'}
              </p>
            </div>
            <div className="badge-pill gold-pill desktop-only" style={{ marginBottom: 0 }}>
              {isAdmin ? '👑 Admin Mode' : 'Live Dashboard'}
            </div>
          </div>
        </div>

        {/* Slider Banner */}
        <div className="max-width">
          <div className="slider-container glass-card" style={{ overflow: 'hidden', padding: 0, margin: '0 0 30px 0', border: '1px solid rgba(255,255,255,0.1)' }}>
            <div className="slider-wrapper">
              <AnimatePresence mode='wait'>
                <motion.div 
                  key={currentSlide}
                  className="slide clickable-slide"
                  onClick={() => handleBannerClick(sliderImages[currentSlide].link)}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={sliderImages[currentSlide].url} alt={sliderImages[currentSlide].title} className="slide-image" />
                </motion.div>
              </AnimatePresence>
              
              <button className="slider-btn prev" onClick={prevSlide}>❮</button>
              <button className="slider-btn next" onClick={nextSlide}>❯</button>
              
              <div className="slider-dots">
                {sliderImages.map((_, index) => (
                  <span key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 60/40 Split Layout */}
        <div className="max-width main-content-layout">
          <div className="left-column">
            <div className="video-container glass-card">
              <VideoPlayer />
              
              <div className="social-actions" style={{ marginTop: '20px', padding: '10px 0', borderTop: '1px solid rgba(255,255,255,0.05)' }}>   
                
                <div className="reaction" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                  <div className="like" onClick={handleToggleLike} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.05)', padding: '8px 16px', borderRadius: '50px' }}>
                    <span role="img" aria-label="like">
                      {liked ? <FavoriteOutlinedIcon style={{ color: '#F59E0B' }} /> : <FavoriteBorderOutlinedIcon style={{ color: '#94A3B8' }} />}
                    </span>
                    <span className="count" style={{ color: '#fff', fontWeight: 'bold' }}>{totalLikes !== null ? totalLikes : 0}</span>
                  </div>

                  <div className="comment-count" onClick={() => setIsCommentsModalOpen(true)} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.05)', padding: '8px 16px', borderRadius: '50px' }}>
                    <span role="img" aria-label="comment">💬</span>
                    <span className="count" style={{ color: '#fff', fontWeight: 'bold' }}>{totalComments}</span>
                    <span className="label" style={{ color: '#94A3B8', fontSize: '0.85rem' }}>Comments</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="right-column">
            <div className="recommended-videos glass-card" style={{ padding: '24px' }}>
              <h4 style={{ fontSize: '1.2rem', marginBottom: '16px', color: '#fff' }}>🔥 Trending <span className="text-gradient-gold">Videos</span></h4>
              <div className="video-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {trendingVideos.map(vid => (
                  <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')} style={{ display: 'flex', gap: '12px', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
                    <div className="thumb-container" style={{ width: '100px', height: '65px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
                      <img src={vid.thumb} alt={vid.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div className="vid-details" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <p style={{ fontSize: '0.9rem', color: '#fff', fontWeight: '600', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{vid.title}</p>
                      <span className="vid-action" style={{ fontSize: '0.75rem', color: '#9333EA', fontWeight: 'bold' }}>Get App to Watch →</span>
                    </div>
                  </div>
                ))}
              </div>

              <h4 className="mt-4" style={{ fontSize: '1.2rem', margin: '24px 0 16px', color: '#fff' }}>📚 Training <span className="text-gradient">Videos</span></h4>
              <div className="video-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {trainingVideos.map(vid => (
                  <div key={vid.id} className="video-item" onClick={() => window.open(APP_DOWNLOAD_LINK, '_blank')} style={{ display: 'flex', gap: '12px', cursor: 'pointer', background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
                    <div className="thumb-container" style={{ width: '100px', height: '65px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
                      <img src={vid.thumb} alt={vid.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div className="vid-details" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <p style={{ fontSize: '0.9rem', color: '#fff', fontWeight: '600', marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{vid.title}</p>
                      <span className="vid-action" style={{ fontSize: '0.75rem', color: '#9333EA', fontWeight: 'bold' }}>Get App to Watch →</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </main>

      {/* Comments Modal */}
      <AnimatePresence>
        {isCommentsModalOpen && (
          <motion.div 
            className="modal-overlay active"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsCommentsModalOpen(false)}
          >
            <motion.div 
              className="modal-card glass-card"
              style={{ width: '95%', maxWidth: '600px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', padding: '0', margin: 'auto' }}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 50, opacity: 0 }}
              transition={{ type: 'spring', damping: 25 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header" style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0 }}>
                <h3 style={{ margin: 0, fontSize: '1.25rem', color: '#fff' }}>💬 Comments</h3>
                <button style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '1.5rem', cursor: 'pointer' }} onClick={() => setIsCommentsModalOpen(false)}>
                  <CloseIcon />
                </button>
              </div>

              <div style={{ padding: '20px 24px', flex: 1, overflowY: 'auto' }}>
                
                {/* Comment Input */}
                <div style={{ background: 'rgba(0,0,0,0.3)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)', marginBottom: '24px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <img src={currentUser?.picturePath || defaultProfileImg} alt="Profile" style={{ width: '36px', height: '36px', borderRadius: '50%' }} />
                    <input
                      type="text"
                      placeholder="Write a comment..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      style={{ flex: 1, background: 'transparent', border: 'none', color: '#fff', outline: 'none', fontSize: '0.95rem' }}
                    />
                  </div>
                  <button onClick={handleCreateComment} disabled={loading} className="btn btn-primary btn-full">
                    {loading ? 'Sending...' : 'Post Comment'}
                  </button>
                </div>

                <div className="comments-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {comments.length === 0 ? (
                    <div className="text-center" style={{ padding: '40px 0', color: '#94A3B8' }}>
                      <span style={{ fontSize: '3rem', display: 'block', marginBottom: '10px' }}>💭</span>
                      <p>No comments yet. Be the first to comment!</p>
                    </div>
                  ) : (
                    comments.map((comment) => (
                      <div className="comment" key={comment._id} style={{ display: 'flex', gap: '12px', background: 'rgba(255,255,255,0.02)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
                        <img src={comment.picture?.uri || defaultProfileImg} alt="" style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                        <div style={{ width: '100%', overflow: 'hidden' }}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                            <span style={{ fontWeight: 'bold', color: '#fff', fontSize: '0.9rem' }}>{comment.name}</span>
                            <span style={{ background: 'rgba(37, 99, 235, 0.15)', color: '#60A5FA', padding: '2px 8px', borderRadius: '20px', fontSize: '0.7rem', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                              {comment.department}
                            </span>
                          </div>
                          <p style={{ color: '#E2E8F0', marginBottom: '6px', fontSize: '0.9rem', lineHeight: '1.4', wordBreak: 'break-word' }}>{comment.text}</p>
                          <span style={{ fontSize: '0.7rem', color: '#64748B' }}>
                            {new Date(comment.createdAt).toLocaleString()}
                          </span>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Home;